// import React, { useEffect, useMemo, useState, useRef } from "react";
// import { Box, IconButton } from "@mui/material";
// import { ErrorLog } from "../common/ErrorLog";
// import {
//   Input,
//   Select,
//   Tag,
//   message,
//   Button,
//   Spin,
//   Modal,
//   Tooltip,
//   Form,
//   notification,
//   Popconfirm,
//   Skeleton,
//   Empty
// } from "antd";
// import { QuestionCircleOutlined } from '@ant-design/icons';
// import { LoadingOutlined } from '@ant-design/icons';
// import { useMsal } from "@azure/msal-react";
// import { MdOutlineArrowBackIos } from "react-icons/md";
// import { MdOutlineArrowForwardIos } from "react-icons/md";
// import { MaterialReactTable } from "material-react-table";
// import { Timesheetapi } from "../../middleware/interceptor";
// import Flatpickr from "react-flatpickr";
// import "flatpickr/dist/flatpickr.css";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { ExclamationCircleFilled } from "@ant-design/icons";
// import dayjs from "dayjs";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { TimeField } from "@mui/x-date-pickers/TimeField";
// import { Activity_log } from "../../components/common/Activity_log";
// import { GoBug } from "react-icons/go";
// import { BiTask } from "react-icons/bi";
// import { AiOutlineDelete } from "react-icons/ai";
// import { AudioOutlined } from "@ant-design/icons";
// import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
// import { createPortal } from "react-dom";
// import { ColorLens } from "@mui/icons-material";
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import TextArea from "antd/es/input/TextArea";
// import { FiClock } from "react-icons/fi";
// import { IoCalendarOutline } from "react-icons/io5";
// import utc from "dayjs/plugin/utc";
// import { DeleteOutlined } from '@ant-design/icons';
// import StatusTable from "../sections/StatusTable";

// const { Search } = Input;
// const suffix = (
//   <AudioOutlined
//     style={{
//       fontSize: 16,
//       color: "#1677ff",
//     }}
//   />
// );
// const onSearch = (value, _e, info) =>
//   console.log(info === null || info === void 0 ? void 0 : info.source, value);

// export const Timesheet = ({ isAuthenticated, employee_id }) => {

//   dayjs.extend(utc);
//   const [approvedTableData, setApprovedTableData] = useState([]);
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [isListExpanded, setIsListExpanded] = useState(true);
//   const dropdownRef = useRef(null);
//   const [isResizing, setIsResizing] = useState(false);
//   const [size, setSize] = useState({ width: 700, height: 250 });
//   const [form] = Form.useForm();
//   const currentDate = new Date();
//   const currentDay = currentDate.getDate();
//   const currentWeekDay = currentDate.getDay();
//   const startOfWeek = new Date(currentDate);

//   startOfWeek.setDate(
//     currentDay - (currentWeekDay === 0 ? 6 : currentWeekDay - 1)
//   );
//   const today = new Date();

//   const [selectedDates, setSelectedDates] = useState([]);
//   const { instance } = useMsal();
//   const activeAccount = instance?.getActiveAccount();
//   const name = activeAccount?.name || "";

//   const [tableData, setTableData] = useState([]);
//   const [temptableData, settempTableData] = useState([]);
//   const [selectedDate, setSelectedDate] = useState([]);
//   const [defaultvalue, setdefaultvalue] = useState("ME");
//   const [weekapproved, setweekapproved] = useState("0");
//   const [changehours, setchangehours] = useState(dayjs());
//   const [Tasklists, setTasklists] = useState();
//   const [tempoptions, settemoptions] = useState([]);
//   const [project, setProject] = useState([]);
//   const [messageApi, contextHolder] = message.useMessage();
//   const [arrow, setArrow] = useState("Show");
//   const [treeData, settreeData] = useState([]);
//   const [Loading, setLoading] = useState(false);
//   const [timesheet_id, setTimesheet_id] = useState();
//   const [dateList, setDateList] = useState([]);
//   const [pendingAction, setPendingAction] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [rowToDelete, setRowToDelete] = useState(null);
//   const [deletedata, setdeletedata] = useState();
//   const [totalRowCount, setTotalRowCount] = useState(new Array(7).fill(0)); // Initialize an array for 7 columns
//   const [search, setsearch] = useState([]);
//   const [value, setValue] = useState();
//   const [workItemList, setWorkItemList] = useState([]);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [Clients, setClient] = useState([]);
//   const [Requirements, setRequirements] = useState([]);
//   const [dropdownPosition, setDropdownPosition] = useState(null);
//   const [activeRowIndex, setActiveRowIndex] = useState(null);
//   const cellRef = useRef(null);
//   const [expandedProjects, setExpandedProjects] = useState([]);
//   const [isExpandedProject, setIsExpandedProject] = useState(null);
//   const [shouldDelete, setShouldDelete] = useState(false);
//   const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
//   const [taskId, settaskid] = useState({});
//   const [istDate, setIstDate] = useState('');
//   const [Time, setTime] = useState();
//   const [Comments, setComments] = useState();
//   const [inputComments, setInputComments] = useState();
//   const [isLoadComments, setIsLoadComments] = useState(false);
//   const [backupdata, setbackupdata] = useState([]);
//   const [isDeletingComment, setIsDeletingComment] = useState(false);
//   const [dropdownLoad, setDropdownLoad] = useState(false);
//   const [exceededCommentLimit, setExceededCommentLimit] = useState(false);
//   const [changehour, setchangehour] = useState("00:00");
//   const [api, contextHolder1] = notification.useNotification();
//   const [expandedTask, setExpandedTask] = useState(null);
//   const containerRef = useRef(null);
//   const [isTruncated, setIsTruncated] = useState(true);
//   const [projectTotals, setProjectTotals] = useState([]);
//   const itemRefs = useRef({});
// const [truncatedMap, setTruncatedMap] = useState({}); 


//   const projectCards = useMemo(() => {
//     const cardColors = [
//       { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
//       { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
//       { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
//       { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
//       { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
//       { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },

//     ];

//     const projectMap = {};

//     tableData.forEach((row) => {
//       // ✅ FIX: use == instead of === to handle both string '1' and number 1
//       if (
//         row.Defaults == '1' ||
//         row.Project_name === 'Total' ||
//         row.Project_name === 'Select a Task' ||
//         !row.Client_name  // ✅ skip rows with no client name yet
//       ) return;

//       const projectName = row.Client_name;

//       if (!projectMap[projectName]) {
//         projectMap[projectName] = 0;
//       }

//       row.days?.forEach((day) => {
//         day.WorkItems?.forEach((wi) => {
//           projectMap[projectName] += parseInt(wi.task_hours || 0, 10);
//         });
//       });
//     });

//     return Object.entries(projectMap).map(([name, totalMins], index) => {
//       const hours = Math.floor(totalMins / 60);
//       const mins = totalMins % 60;
//       // ✅ FIX: format as HH:MM like "4:25" not "4.25"
//       const formatted = `${hours}:${String(mins).padStart(2, '0')}`;
//       const color = cardColors[index % cardColors.length];
//       return { name, formatted, color };
//     });
//   }, [tableData]);

//   useEffect(() => {
//   const newTruncatedMap = {};
//   Object.keys(itemRefs.current).forEach((key) => {
//     const el = itemRefs.current[key];
//     if (el) {
//       newTruncatedMap[key] = el.scrollWidth > el.clientWidth;
//     }
//   });
//   setTruncatedMap(newTruncatedMap);
// }, [treeData, isListExpanded]);


//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       //  settreeData(search)
//       console.log(dropdownRef.current, "REF DATA");
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownPosition(null);
//         setActiveRowIndex(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [search]);
//   useEffect(() => {
//     if (isLoadComments) {

//       const totalMinutes = dayjs(changehours, "HH:mm").hour() * 60 + dayjs(changehours, "HH:mm").minute();
//       setTime(prevTime => {
//         const updatedTime = parseInt(prevTime) + parseInt(totalMinutes);
//         console.log("Updated Time:", updatedTime);
//         return updatedTime;
//       });
//     }

//   }, [isLoadComments]);
//   useEffect(() => {
//     window.addEventListener("mousemove", resize);
//     window.addEventListener("mouseup", stopResizing);
//     return () => {
//       window.removeEventListener("mousemove", resize);
//       window.removeEventListener("mouseup", stopResizing);
//     };
//   }, [isResizing]);

//   useEffect(() => {


//     const func = async () => {
//       if (shouldDelete) {
//         await handlesubmit();
//         setShouldDelete(false);
//       }
//     }

//     func();
//   }, [tableData, shouldDelete]);

//   useEffect(() => {
//     const observer = new ResizeObserver((entries) => {
//       for (let entry of entries) {
//         if (entry.contentRect.width < 300) {
//           setIsTruncated(true); // small size → truncate
//         } else {
//           setIsTruncated(false); // big size → full title
//         }
//       }
//     });

//     if (containerRef.current) {
//       observer.observe(containerRef.current);
//     }

//     return () => {
//       if (containerRef.current) {
//         observer.unobserve(containerRef.current);
//       }
//     };
//   }, []);
//   useEffect(() => {
//     handleWeekSelection([today]);
//     const selectedDate = today;
//     const startOfWeek = new Date(selectedDate);
//     const dayOfWeek = startOfWeek.getDay();
//     const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
//     startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
//     const endOfWeek = new Date(startOfWeek);
//     endOfWeek.setDate(startOfWeek.getDate() + 6);
//     setSelectedDate([startOfWeek, endOfWeek]);
//   }, []);

//   useEffect(() => {
//     if (
//       selectedDates.length > 0 &&
//       localStorage.getItem("employee_id") != undefined
//     ) {
//       gettimesheetdata();
//       // const OldProjectList = oldProjectList();
//       let startDate = formatDateToDDMMYYYY(new Date(selectedDates[0]));
//       let endDate = formatDateToDDMMYYYY(new Date("2025-01-06"));
//       let tree = transformToTreeData(workItemList);
//       settreeData(tree);
//       settemoptions(tree);
//       setsearch(tree)
//     }
//   }, [selectedDates]);
//   useEffect(() => {
//     const selectedDate = today;
//     const startOfWeek = new Date(selectedDate);
//     const dayOfWeek = startOfWeek.getDay();
//     const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
//     startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
//     if (isAuthenticated || sessionStorage.getItem("AdminLogin") == 'true') {

//       if (localStorage.getItem("employee_id") != null && localStorage.getItem("employee_id") != undefined
//       ) {
//         getprojectname(localStorage.getItem("employee_id"), startOfWeek);
//       }
//     }
//   }, [isAuthenticated, localStorage.getItem("employee_id")]);

//   useEffect(() => {
//     const itemIds =
//       tableData?.flatMap((dayData) =>
//         dayData.days?.flatMap((day) =>
//           day.WorkItems?.map((workItem) => Number(workItem.ItemId))
//         )
//       ) || [];
//     const updatedOptions = tempoptions.map((option) => {
//       if (option.children) {
//         const updatedChildren = option.children.map((child) => {
//           const isDisabled = itemIds.includes(child.value);

//           return {
//             ...child,
//             disabled: isDisabled || false,
//           };
//         });
//         return {
//           ...option,
//           children: updatedChildren,
//         };
//       }
//       return option;
//     });
//     settreeData(updatedOptions);
//     setsearch(updatedOptions)
//   }, [tempoptions, tableData]);

//   useEffect(() => {
//     let rowIndex = 0;
//     if (pendingAction.length > 0) {
//       handleSelectChange(
//         rowIndex,
//         pendingAction[0].extra,
//         pendingAction[0].value,
//         1
//       );
//     }
//   }, [pendingAction]);
//   const mergedArrow = useMemo(() => {
//     if (arrow === "Hide") {
//       return false;
//     }
//     if (arrow === "Show") {
//       return true;
//     }
//     return {
//       pointAtCenter: true,
//     };
//   }, [arrow]);


//   const formatDateToDDMMYYYY = (date) => {
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
//     const day = String(date.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`; // Format as yyyy-mm-dd
//   };

//   const formatDateToYYYYMMDD = (date) => {
//     return dayjs(date).format("YYYY-MM-DD");
//   };

//   const convertDateTime = (utcDateStr) => {
//     return dayjs.utc(utcDateStr).local(); // Returns a Day.js object in local time
//   };

//   function normalizeDate(input) {
//     const isoFormat = /^\d{4}-\d{2}-\d{2}$/;
//     const ddmmyyyyFormat = /^\d{2}-\d{2}-\d{4}$/;

//     let dateObj;

//     if (isoFormat.test(input)) {
//       const [yyyy, mm, dd] = input.split("-").map(Number);
//       dateObj = new Date(Date.UTC(yyyy, mm - 1, dd));
//     } else if (ddmmyyyyFormat.test(input)) {
//       const [dd, mm, yyyy] = input.split("-").map(Number);
//       dateObj = new Date(Date.UTC(yyyy, mm - 1, dd));
//     } else {
//       const parsed = new Date(input);
//       if (!isNaN(parsed)) {
//         dateObj = new Date(Date.UTC(
//           parsed.getFullYear(),
//           parsed.getMonth(),
//           parsed.getDate()
//         ));
//       } else {
//         return null; // invalid
//       }
//     }

//     const yyyy = dateObj.getUTCFullYear();
//     const mm = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
//     const dd = String(dateObj.getUTCDate()).padStart(2, "0");

//     return `${yyyy}-${mm}-${dd}`;
//   }
//   const checkDate = (inputDateStr) => {
//     const inputDate = new Date(inputDateStr);
//     const today = new Date();
//     const yesterday = new Date();
//     yesterday.setDate(today.getDate() - 1);

//     // Format to 'YYYY-MM-DD'
//     const formatDate = (date) => date.toISOString().split('T')[0];

//     const input = formatDate(inputDate);
//     const todayStr = formatDate(today);
//     const yesterdayStr = formatDate(yesterday);

//     if (input === todayStr) {
//       return "Today";
//     } else if (input === yesterdayStr) {
//       return "Yesterday";
//     } else {
//       // Return as "May 18"
//       const options = { month: 'short', day: 'numeric' };
//       return inputDate.toLocaleDateString('en-US', options);
//     }
//   };
//   const openNotification = (message, description) => {
//     api.warning({
//       message,
//       description,
//       placement: 'topRight',
//       key: 'single-instance-notification',
//       duration: 2.5,
//     });
//   };

//   const convertToDDMMYYYY = (dateStr) => {
//     if (!dateStr) return "";

//     const parts = dateStr.split("-");
//     if (parts[0].length === 4) {
//       const [year, month, day] = parts;
//       return `${day}-${month}-${year}`;
//     }
//     if (parts[2].length === 4) {
//       const [day, month, year] = parts;
//       return `${day}-${month}-${year}`;
//     } return dateStr;
//   };

//   const showModal = async (task_Id, rowIndex, dayIndex, Hours, actual, task_Name, task_Date, rowData) => {
//     const workItem = rowData?.days?.[dayIndex]?.WorkItems?.[0];
//     settaskid({
//       task_Id: task_Id,
//       rowIndex: rowIndex,
//       dayIndex: dayIndex,
//       Hours: actual,
//       task_Name,
//       task_Date,
//       task_Description: workItem?.Task_Description || workItem?.ItemDescription || "",
//       Billing_Status: workItem?.Billing_Status || "",
//       current_Total: totalRow.days[dayIndex].task_hours,
//       rowData
//     })

//     setInputComments('')

//     setTime(parseInt(actual))
//     // console.log(original, "oRIGINAL Hours")
//     setchangehours(dayjs("00:00", "HH:mm"));

//     await Timesheetapi.get(`api/Projects/GetComments?empid=${localStorage.getItem("employee_id")}&role_id=${localStorage.getItem("employee_id")}&task_id=${task_Id}&sdate=${task_Date}`).then((Res) => {
//       setComments(Res?.data?.Comments);
//       console.log(Res, "VNNVJN")
//     }).catch((error) => {

//       console.log(error);
//     })
//     setIsProjectModalOpen(true);
//     setExceededCommentLimit(false);
//   };

//   const handleOk = async () => {
//     const parsedChangeHours = dayjs(changehours, "HH:mm");
//     if (!parsedChangeHours.isValid()) {
//       error("Invalid time format.");
//       return;
//     }

//     const formattedHours = parsedChangeHours.format("HH:mm");
//     const totalMinutes = parsedChangeHours.hour() * 60 + parsedChangeHours.minute();

//     const nowDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss");

//     if (exceededCommentLimit) {
//       openNotification('Comment Hour Limit Exceeded', 'Max 4 hours allowed per comment');
//       return;
//     }

//     if (!value || formattedHours === "00:00") {
//       error("Fill the worked Hours.");
//       return;
//     }

//     if (inputComments.trim() === "") {
//       error("Fill the Comments.");
//       return;
//     }

//     setIsLoadComments(true);

//     const newComment = {
//       Changed_Hrs: formattedHours,
//       Created: nowDateTime,
//       content: inputComments.replace(/ /g, '&nbsp;').replace(/\n/g, '<br>')
//     };

//     const payload = {
//       task_Id: taskId.task_Id,
//       Changed_date: normalizeDate(taskId.task_Date),
//       comments_html: newComment.content,
//       raw_comments: inputComments,
//       commented_By_Id: localStorage.getItem("employee_id"),
//       changed_hours: formattedHours,
//     };

//     console.log("payloadgenerated", payload)


//     //For Change Log
//     const tempData = taskId.rowData
//     const beforeChanges = structuredClone(taskId.rowData);

//     const Constant_Data = {
//       client_Details: {
//         client_Id: tempData.Client_id,
//         client_Name: tempData.Client_name,
//       },
//       project_Details: {
//         project_Id: tempData.Project_id,
//         project_Name: tempData.Project_name,
//       },
//       task_Details: {
//         task_Id: tempData.days?.[0]?.WorkItems?.[0]?.ItemId,
//         task_Name: tempData.days?.[0]?.WorkItems?.[0]?.ItemName,
//       },
//       employee_Details: {
//         employee_Id: tempData.Employee_id,
//         emp_Name: name,
//       },
//     };

//     const After_Changes = {
//       ...structuredClone(taskId.rowData),
//       days: taskId.rowData.days?.map((day, index) => {
//         if (index !== taskId.dayIndex) return structuredClone(day);

//         return {
//           ...structuredClone(day),
//           WorkItems: day.WorkItems?.map((workItem, idx) => {
//             if (idx !== 0) return structuredClone(workItem);

//             return {
//               ...structuredClone(workItem),
//               task_hours: String(
//                 parseInt(workItem.task_hours, 10) + formatTimeHHmm(payload.changed_hours)
//               ),
//             };
//           }),
//         };
//       }),
//     };

//     const Changes_Done = {
//       change_Summary: `Task hours have been updated from ${formatTimes(tempData.days?.[taskId.dayIndex]?.WorkItems?.[0]?.task_hours)} hrs to ${formatTimes(parseInt(tempData.days?.[taskId.dayIndex]?.WorkItems?.[0]?.task_hours, 10) + formatTimeHHmm(formattedHours))} hrs on ${formatTimeMMDDYYYY(tempData.days?.[taskId.dayIndex]?.date)}. The update was performed on ${formatTimeWithUserTimezone()}, by ${name}.`,
//       change_For_Date: taskId.task_Date,
//       change_On_Date: formatDateToYYYYMMDD(new Date().toISOString()),
//       change_Time: convertDateTime(new Date().toISOString()),
//       Added_Comments: payload.raw_comments,
//       Added_Comments_Html_Format: payload.comments_html,
//     };

//     // Final payload object
//     const change_log = {
//       Constant_Data,
//       Before_Changes: beforeChanges,
//       After_Changes,
//       Changes_Done,
//     };



//     console.log("change_log", change_log)




//     try {
//       const addition = Time + totalMinutes;
//       const finalTime = await formatTime(addition);
//       const parsedFinalTime = dayjs(finalTime, "HH:mm");

//       console.log(Time, totalMinutes, payload, "Console")
//       await handleInputChange(taskId.rowIndex, taskId.dayIndex, parsedFinalTime.format("HH:mm"));

//       const res = await Timesheetapi.post(`api/Projects/PutComments`, payload);

//       if (res.data.status === "success") {
//         const Res = await Timesheetapi.get(
//           `api/Projects/GetComments?empid=${localStorage.getItem("employee_id")}&role_id=${localStorage.getItem("employee_id")}&task_id=${taskId.task_Id}&&sdate=${taskId.task_Date}`);
//         setComments(Res?.data?.Comments);
//         await handlesubmit();

//         setchangehours(dayjs("00:00", "HH:mm"));
//         success("Updated successfully.");
//       }

//     } catch (err) {
//       console.error("❌ Failed to save comment:", err);
//       error("Failed to save comment.");
//     } finally {
//       setInputComments('');
//       setIsLoadComments(false);
//     }
//   };
//   const handleClear = () => {
//     setInputComments('')
//     setchangehours(dayjs("00:00", "HH:mm"));
//     setExceededCommentLimit(false);
//   };

//   const handleCancel = () => {
//     setIsProjectModalOpen(false);
//   };

//   const handleCellClick = (event, row) => {
//     const rect = event.currentTarget.getBoundingClientRect();
//     setDropdownPosition({
//       top: rect.bottom + window.scrollY,
//       left: rect.left + window.scrollX,
//     });
//     setActiveRowIndex(row.index);
//   };

//   const formatIst = (_Date) => {
//     const date = new Date(_Date);

//     const options = {
//       timeZone: 'Asia/Kolkata',
//       year: 'numeric',
//       month: 'short',
//       day: '2-digit',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true,
//     };

//     const istString = date.toLocaleString('en-US', options); // e.g. "May 20, 2025, 07:44 PM"

//     // Split full date and time
//     const parts = istString.split(', '); // ["May 20", "2025", "07:44 PM"]

//     return {
//       date: `${parts[0]}, ${parts[1]}`, // "May 20, 2025"
//       time: parts[2]                    // "07:44 PM"
//     };
//   };

//   const handleToggle = (key) => {
//     setIsExpandedProject((prev) => (prev === key ? null : key));
//   };
//   const handleListToggle = () => {
//     setIsListExpanded(!isListExpanded);
//   };

//   const startResizing = (e) => {
//     e.preventDefault();
//     setIsResizing(true);
//   };

//   const stopResizing = () => {
//     setIsResizing(false);
//   };

//   const resize = (e) => {
//     if (isResizing && dropdownRef.current) {
//       const rect = dropdownRef.current.getBoundingClientRect();
//       const newWidth = e.clientX - rect.left;
//       const newHeight = e.clientY - rect.top;

//       setSize({
//         width: Math.max(245, newWidth), // keeping min width
//         height: Math.max(150, newHeight),
//       });
//     }
//   };

//   const toggleModal = () => {
//     setIsModalVisible({ visible: false, name: '' });
//     form.resetFields();
//   };


//   const success = (msg) => {
//     messageApi.destroy();
//     messageApi.open({
//       type: "success",
//       title: "Success",
//       content: msg,
//       duration: 1.5,
//     });
//   };
//   const error = (msg) => {
//     messageApi.destroy();
//     messageApi.open({
//       type: "error",
//       duration: 1.5,
//       content: msg,
//     });
//   };
//   const warning = () => {
//     messageApi.destroy();
//     messageApi.open({
//       type: "warning",
//       title: "Warning",
//       duration: 1.5,
//       content: "No more project available",
//     });
//   };

//   const handleToggleProject = (projectId) => {
//     setExpandedProjects((prev) =>
//       prev.includes(projectId)
//         ? prev.filter((id) => id !== projectId)
//         : [...prev, projectId]
//     );
//   };

//   const getprojectname = async (username, date) => {
//     // const OldProjectList = oldProjectList();
//     //////  new change in implement Task udates ////////
//     setDropdownLoad(true);
//     const Tasklist = await Timesheetapi.get(
//       `api/Projects/listWorkItemsOfEmployee?emp_id=${username}&&Role_id=${(localStorage.getItem('emp_role_id'))}`
//     );

//     console.log("First task sample:", Tasklist.data.Task_list[0]);
//   console.log("Ticket_id values:", Tasklist.data.Task_list.map(t => ({ Item_id: t.Item_id, Item_Name: t.Item_Name, Ticket_id: t.Ticket_id })));
//     setWorkItemList(Tasklist.data.Task_list);
//     let startDate = formatDateToDDMMYYYY(new Date(date));
//     let endDate = formatDateToDDMMYYYY(new Date("2025-01-06"));
//     let tree = transformToTreeData(Tasklist.data.Task_list);

//     settreeData(tree);
//     setsearch(tree)

//     console.log(tree, "task lists");
//     settemoptions(tree);
//     setDropdownLoad(false);
//   };

//   const handleDeleteRow = (rowIndex, row) => {
//     setRowToDelete(rowIndex); // Set the row to delete
//     setIsModalOpen(true);
//     setdeletedata(row.original.Project_id);
//   };

//   const confirmDelete = async () => {
//     // Filter out the row to delete
//     setTableData((prevData) => {
//       const newData = prevData.filter((_, index) => index !== rowToDelete);

//       // Use the updated table data to set the disabled status
//       const updatedOptions = tempoptions.map((option) => {
//         const isDisabled = newData.some((item) => item.Project_id == option.id);
//         return {
//           ...option,
//           disabled: isDisabled,
//         };
//       });
//       setIsModalOpen(false);
//       setRowToDelete(null);
//       setProject(updatedOptions);

//       return newData;
//     });
//     setShouldDelete(true);
//   };

//   const cancelDelete = () => {
//     setIsModalOpen(false); // Close the modal without deleting
//     setRowToDelete(null);
//   };

//   const handleAddRow = (rowIndex, field, value, extra) => {
//     console.log("LogDATA", extra);

//     // Accepts either a Date object or an ISO string like "2025-05-26"
//     const parseLocalDate = (input) => {
//       if (input instanceof Date) {
//         return new Date(input.getFullYear(), input.getMonth(), input.getDate());
//       }
//       if (typeof input === "string" && input.includes("-")) {
//         const [year, month, day] = input.split("-").map(Number);
//         return new Date(year, month - 1, day);
//       }
//       throw new Error("Invalid input to parseLocalDate");
//     };

//     // Format a Date object to DD-MM-YYYY
//     const formatDateToDDMMYYYY = (date) => {
//       const day = String(date.getDate()).padStart(2, "0");
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${year}-${month}-${day}`;
//     };

//     const startDate = parseLocalDate(selectedDates[0]);
//     const endDate = parseLocalDate(selectedDates[1]);

//     const weekDates = [];
//     let currentDate = new Date(startDate);

//     while (currentDate <= endDate) {
//       weekDates.push(formatDateToDDMMYYYY(currentDate));
//       currentDate.setDate(currentDate.getDate() + 1);
//     }

//     const daysArray = weekDates.map((date) => ({
//       task_hours: 0,
//       date: date,
//     }));

//     console.log(weekDates, "weekDates");

//     let prodcm = [];

//     if (prodcm.length <= project.length) {
//       prodcm = [
//         { project: "", task: "", Defaults: "0", days: daysArray },
//         ...tableData,
//       ];

//       const projects = prodcm.filter((item) => item?.Defaults === "0");

//       setTableData([{ Defaults: "0", days: daysArray }, ...tableData]);
//       setPendingAction([
//         {
//           Defaults: "0",
//           days: daysArray,
//           rowIndex,
//           field,
//           value,
//           extra,
//         },
//         ...tableData,
//       ]);
//     } else {
//       toast.warning("No project available");
//     }
//   };

//   const transformToTreeData = (Tasklists) => {
//     const groupedData = {};

//     // Group items by `Req_id` - filter out Sales items
//     Tasklists.forEach((task) => {
//       // Skip Sales items - they should not appear in activity card
//       if (task.Item_type === "Sales") {
//         return;
//       }

//       if (!groupedData[task.Item_id]) {
//         groupedData[task.Item_id] = {
//           // title: (
//           //   <p className="font-mediums w-[100%] truncate text-[12px]">
//           //     {/* {task.Client_name} - */}
//           //     {task.Client_name} -  {task.Project_name} / {`Task - ${task.Item_Name}`}
//           //   </p>
//           // ),

//           title: (
//             <p className="font-mediums w-[100%] min-w-0 truncate text-[12px] text-left">
//               {task.Client_name} - {task.Project_name}

//               {/* ✅ Conditional Track / Module */}
//               {(task.Track_Name || task.Module_Name) && (
//                 <> / {task.Track_Name || ""}{task.Module_Name ? ` / ${task.Module_Name}` : ""}</>
//               )}


//              {" / "}Task -{" "}
// {(() => {
//   const ticketId = task.Ticket_id ? String(task.Ticket_id).trim() : "";
//   console.log("Ticket ID:", ticketId, "Item Name:", task.Item_Name); // Debug log
//   const itemName = task.Item_Name || "";
//   const ticketIsValid = ticketId.toLowerCase().startsWith("#inc-");
//   const nameAlreadyHasTicket = itemName.trim().toLowerCase().startsWith("#inc-");
//   return (
//     <>
//       {ticketIsValid && !nameAlreadyHasTicket && (
//         <span className="font-medium mr-1">{ticketId}</span>
//       )}
//       {itemName}
//     </>
//   );
// })()}


//             </p>
//           ),
//           value: task.Project_id,
//           key: task.Project_id,
//           selectable: false,
//           children: [],
//         };
//       }
//       groupedData[task.Item_id].children.push({
//         title: (
//           <div className="flex items-center justify-between w-full pr-2">
//             <span className="flex items-center gap-2">
//               {task.Item_type === "Task" ? (
//                 <BiTask className="text-[#f3d138] text-[17px]" />
//               ) : (
//                 <GoBug className="text-[red] text-[15px]" />
//               )}
// {/* 
//               {"Task"} - {task.Item_Name} */}

//               {"Task"} -{" "}
// {(() => {
//   const ticketId = task.Ticket_id ? String(task.Ticket_id).trim() : "";
//   const itemName = task.Item_Name || "";
//   const ticketIsValid = ticketId.toLowerCase().startsWith("#inc-");
//   const nameAlreadyHasTicket = itemName.trim().toLowerCase().startsWith("#inc-");
//   return (
//     <>
//       {ticketIsValid && !nameAlreadyHasTicket && (
//         <span className="text-[#6b7280] font-medium mr-1">{ticketId}</span>
//       )}
//       {itemName}
//     </>
//   );
// })()}


//             </span>

//             <Tooltip title="Delete Task">
//               <AiOutlineDelete
//                 className="text-gray-400 hover:text-red-500 cursor-pointer"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   // handleDeleteTask(task.Item_id);
//                 }}
//               />
//             </Tooltip>
//           </div>
//         ),
//         value: task.Item_id,
//         key: task.Item_id,
//         client_id: task.Client_id,
//         project_id: task.Project_id,
//         client_name: task.Client_name,
//         Project_name: task.Project_name,
//         Expire_Date: task.Project_End_Date,

//         //project_name: task.Client_name + ' / ' + task.Project_name + ' / ' + `Task - ${task.Item_Name}`,


//         project_name: (() => {
//   const ticketId = task.Ticket_id ? String(task.Ticket_id).trim() : "";
//   const itemName = task.Item_Name || "";
//   const ticketIsValid = ticketId.toLowerCase().startsWith("#inc-");
//   const nameAlreadyHasTicket = itemName.trim().toLowerCase().startsWith("#inc-");
//   const taskLabel = ticketIsValid && !nameAlreadyHasTicket
//     ? `Task - ${ticketId} ${itemName}`
//     : `Task - ${itemName}`;
//   return task.Client_name + ' / ' + task.Project_name + ' / ' + taskLabel;
// })(),

//         Track_Name: task.Track_Name || null,   // ✅ ADD
//         Module_Name: task.Module_Name || null, // ✅ ADD

//         Req_id: task.Req_id,
//         Item_Name: task.Item_Name,
//         Req_name: task.Req_name,
//         Item_type: task.Item_type,
//         Item_status: task.Item_status,
//         Status: task.Status,
//         Ticket_id: task.Ticket_id || "",
//         disabled: false,
//       });
//     });

//     return Object.values(groupedData);
//   };

//   const onChange = (rowIndex, newValue, extra) => {
//     setValue(newValue);

//     //rowIndex=rowIndex-1;

//     const selectedNode = extra.triggerNode?.props;

//     const updatedData = [...tableData];

//     updatedData[rowIndex] = {
//       ...updatedData[rowIndex],
//       Project_name: selectedNode.project_name,
//       Project_id: selectedNode.project_id,
//       Employee_id: employee_id,
//       Client_id: selectedNode.client_id,
//       Client_name: selectedNode.client_name,
//       //Expire_Date: filter[3],
//       //days: transformedData[rowIndex]?.days || []  // Merge the transformed days here
//     };
//   };

//   const handleSelectChange = (rowIndex, treevalue, value, update) => {
//     rowIndex = rowIndex;

//     const selectedNode = treevalue?.triggerNode?.props;

//     console.log(selectedNode, "selectedNode");

//     const updatedData = [...tableData];

//     let transformedData;
//     if (update == 0) {
//       transformedData = tableData.map((client) => ({
//         days: client.days.map((day) => ({
//           date: day.date,
//           WorkItems: [
//             {
//               ...day,
//               task_hours: day.WorkItems[0]["task_hours"],
//               ReqId: selectedNode?.Req_id,
//               ItemId: value,
//               ItemName: selectedNode?.Item_Name,
//               itemtype: selectedNode?.Item_type,
//               ReqName: selectedNode?.Req_name,
//               Item_status: selectedNode?.Item_status,
//               Track_Name: selectedNode?.Track_Name || null,   // ✅ ADD
//               Module_Name: selectedNode?.Module_Name || null, // ✅ ADD
//               Ticket_id: selectedNode?.Ticket_id || "",
//             },
//           ],
//         })),
//       }));
//     } else {
//       transformedData = tableData.map((client) => ({
//         days: client.days.map((day) => ({
//           date: day.date,
//           WorkItems: [
//             {
//               ReqId: selectedNode?.Req_id,
//               ItemId: value,
//               ItemName: selectedNode.Item_Name,
//               itemtype: selectedNode.Item_type,
//               ReqName: selectedNode?.Req_name,
//               Item_status: selectedNode.Item_status,
//               Track_Name: selectedNode?.Track_Name || null,   // ✅ ADD
//               Module_Name: selectedNode?.Module_Name || null, // ✅ ADD

//               Ticket_id: selectedNode?.Ticket_id || "",
//               ...{ ["task_hours"]: day["task_hours"] },
//             },
//           ],
//         })),
//       }));
//     }

//     updatedData[rowIndex] = {
//       ...updatedData[rowIndex],
//       Project_name: selectedNode?.Project_name,
//       Project_id: selectedNode?.project_id,
//       Employee_id: employee_id,
//       Client_id: selectedNode?.client_id,
//       Client_name: selectedNode?.client_name,
//       Expire_Date: selectedNode.Expire_Date,
//       days: transformedData[rowIndex]?.days || [],
//     };
//     //setSelectedvalue(value);
//     setTableData(updatedData);
//     setweekapproved("0");
//   };
//   const handleSelectChangeselect = (rowIndex, field, value, extra) => {
//     rowIndex = rowIndex - 1;
//     handleAddRow(rowIndex, field, value, extra);
//   };



//   const handlesubmit = async () => {
//     let payload_log = {};
//     const startDate = formatDateToDDMMYYYY(new Date(selectedDates[0]));
//     const endDate = formatDateToDDMMYYYY(new Date(selectedDates[1]));

//     // setLoading(true);

//     let transformedTableData = [];

//     // transformedTableData = tableData?.filter((item) => {
//     //   const hasProjectStatus = item?.Project_Status == 1;

//     //   const hasTaskStatus = item?.days?.some(day => day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 0));

//     //   return hasProjectStatus &&  hasTaskStatus;
//     // });

//     // let filters = [];

//     // filters = backupdata?.WeekData?.filter(item => {
//     //   const hasProjectStatus = item?.Project_Status != 1;

//     //   const hasTaskStatus = item?.days?.some(day =>
//     //     day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 1)
//     //   );

//     //   console.log(hasTaskStatus, hasProjectStatus, "hasTaskStatus");

//     //   return hasProjectStatus || hasTaskStatus;
//     // });


//     // let arrays = [
//     //   ...transformedTableData,
//     //   ...(filters?.length > 0 ? filters : []),
//     // ];


//     // console.log(filters, arrays, "tableDataTransform");


//     const payload = {
//       Timesheet_id: timesheet_id,
//       WeekStartDate: startDate,
//       Weekend_date: endDate,
//       EmployeeId: localStorage.getItem('employee_id'),
//       tableData: tableData,

//     };

//     // console.log(filters, arrays, "tableDataTransform");


//     const filter = tableData.filter((item) => item.Defaults === 0);

//     await Timesheetapi.post("api/Projects/AddEmployeeWorkingHours", payload)
//       .then(async (response) => {
//         success(shouldDelete ? "Successfully Deleted " : "Successfully submitted for approval");

//         await gettimesheetdata();
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.log(error, "error");
//       });
//   };

//   const isSameDay = (date1, date2) => {
//     return (
//       date1.getDate() >= selectedDate[0].getDate() &&
//       date1.getDate() <= date2.getDate() &&
//       date1.getMonth() >= selectedDate[0].getMonth() &&
//       date1.getMonth() <= date2.getMonth() &&
//       date1.getFullYear() >= selectedDate[0].getFullYear() &&
//       date1.getFullYear() <= date2.getFullYear()
//     );
//   };

//   const formatTime = (minutes) => {
//     const hours = Math.floor(minutes / 60);
//     const mins = minutes % 60;
//     return dayjs().hour(hours).minute(mins);
//   };

//   const formatTimeHHmm = (strHHmm) => {
//     const [hours, minutes] = strHHmm.split(":").map(Number);
//     const totalMinutes = hours * 60 + minutes;
//     return totalMinutes;
//   };

//   const formatTimeMMDDYYYY = (dateStr) => {
//     const dateDayjs = new Date(dateStr + "T00:00:00");
//     const formattedDate = dateDayjs.toLocaleDateString("en-US", {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//     });
//     return formattedDate;
//   };

//   const formatTimeWithUserTimezone = () => {
//     const now = new Date();
//     // Detect user's time zone automatically
//     const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
//     return now.toLocaleString("en-US", {
//       timeZone: userTimeZone,
//       month: "long",
//       day: "numeric",
//       year: "numeric",
//       hour: "numeric",
//       minute: "2-digit",
//       hour12: true,
//       timeZoneName: "short"
//     });
//   };


//   const handleInputChange = (rowIndex, dayIndex, value) => {
//     const [hours, minutes] = value.split(":").map((v) => parseInt(v, 10));
//     const totalMinutes = (hours || 0) * 60 + (minutes || 0);
//     const updatedData = [...tableData];
//     // updatedData[rowIndex].days[dayIndex]["task-hours"] = totalMinutes;
//     updatedData[rowIndex].days[dayIndex].WorkItems[0]["task_hours"] =
//       totalMinutes;
//     updatedData[rowIndex].days[dayIndex].WorkItems[0]["Updated"] = true;
//     const newTotals = new Array(7).fill(0);
//     updatedData.forEach((row) => {
//       row.days.forEach((day, idx) => {
//         newTotals[idx] += Number(day["task_hours"] || 0);
//       });
//     });

//     console.log(updatedData, "updatedData");
//     setTableData(JSON.parse(JSON.stringify(updatedData)));
//     setTotalRowCount(newTotals.map(formatTime));
//   };

//   const handleWeekSelection = (selectedDates) => {
//     if (selectedDates.length > 0) {
//       // Normalize input date to local midnight
//       const selectedDate = new Date(
//         selectedDates[0].getFullYear(),
//         selectedDates[0].getMonth(),
//         selectedDates[0].getDate()
//       );

//       const dayOfWeek = selectedDate.getDay();
//       const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

//       const startOfWeek = new Date(selectedDate);
//       startOfWeek.setDate(selectedDate.getDate() - daysToMonday);

//       const endOfWeek = new Date(startOfWeek);
//       endOfWeek.setDate(startOfWeek.getDate() + 6);

//       // Save clean week dates (still Date objects)
//       setSelectedDates([startOfWeek, endOfWeek]);

//       // Build date list for headers
//       const newDateList = Array.from({ length: 7 }, (_, index) => {
//         const date = new Date(
//           startOfWeek.getFullYear(),
//           startOfWeek.getMonth(),
//           startOfWeek.getDate() + index
//         );

//         const formattedDate = date.toLocaleDateString("en-US", {
//           weekday: "short",
//           month: "short",
//           day: "numeric",
//         });

//         return {
//           accessorKey: formattedDate,
//           header: formattedDate,
//         };
//       });

//       setDateList(newDateList);
//     }
//   };

//   const gettimesheetdata = async () => {
//     const startDate = formatDateToDDMMYYYY(new Date(selectedDates[0])); // Convert start date
//     const endDate = formatDateToDDMMYYYY(new Date(selectedDates[1])); // Convert end date
//     setLoading(true);

//     try {
//       const response = await Timesheetapi.get(
//         `api/Projects/GetEmployeeWorkingHours?empid=${localStorage.getItem("employee_id")}&sdate=${startDate}&edate=${endDate}&Role_id=${localStorage.getItem("emp_role_id")}&Teamleadid=${localStorage.getItem("employee_id")}`
//       );

//       setLoading(false);

//       if (response?.data?.WeekData && response.data.WeekData.length > 0) {

//         console.log(response.data.WeekData);

//         try {
//           getApprovalsDetails(localStorage.getItem("employee_id"), startDate, endDate)

//         }
//         catch (exception) {

//         }

//         // let filter = [];

//         // response.data.WeekData.forEach(item => {
//         //   const hasProjectStatus = item?.Project_Status == 1;
//         //   const hasTaskStatus = item?.days?.some(day =>
//         //     day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 0)
//         //   );

//         //   if (hasProjectStatus) filter.push(item);
//         //   if (hasTaskStatus) filter.push(item);
//         // });

//         let filter = response.data.WeekData.filter(item => {
//           const hasProjectStatus = item?.Project_Status == 1;


//           const hasTaskStatus = item?.days?.some(day => day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 0));



//           console.log(hasProjectStatus, hasTaskStatus, "DADADADAD")

//           return hasProjectStatus && hasTaskStatus;
//         });

//         console.log(filter, response.data.WeekData, "filterData")
//         setbackupdata(response.data);

//         setTableData(JSON.parse(JSON.stringify(response.data.WeekData)));

//         setTimesheet_id(response.data.Timesheet_id || "");

//         const filterser = response.data.WeekData.filter(item => item.Defaults === 0);

//         if (filterser.length > 0) {
//           // Check if every item in filterser has Approved_status == 1
//           const filters = filterser.every(item => item.Approved_status === 1);
//           setweekapproved(filters ? "1" : "0");
//         } else {
//           setweekapproved("0");
//         }
//       } else {
//         setTableData([]);
//         setweekapproved("0");
//         setApprovedTableData([]);
//         setTimesheet_id("");
//       }

//       if (response?.data) {
//         settempTableData(JSON.parse(JSON.stringify(response.data)));
//       } else {
//         settempTableData([]);
//         setApprovedTableData([]);
//       }

//     } catch (error) {
//       setLoading(false);
//       setTableData([]);
//       settempTableData([]);
//       setApprovedTableData([]);
//       setweekapproved("0");
//       setTimesheet_id("");
//       console.error("Failed to fetch timesheet data:", error);

//       const errorLog = {
//         Error_Message: error,
//         Stack_Trace: '',
//         Method_Name: `api/Projects/GetEmployeeWorkingHours?empid=${localStorage.getItem("employee_id")}&sdate=${startDate}&edate=${endDate}&Role_id=${localStorage.getItem("emp_role_id")}&Teamleadid=${localStorage.getItem("employee_id")}`,
//         File_Name: 'Timesheet.js',
//         User_Id: localStorage.getItem("employee_id"),
//       };
//       ErrorLog(errorLog)

//     }
//   };
//   const getApprovalsDetails = async (empid, sdate, edate) => {

//     await Timesheetapi.get(`api/Projects/getApprovaldetrails?empid=${empid}&&sdate=${sdate}&edate=${edate}`).then((Res) => {

//       let Approvals = Res.data.Approvals;

//       if (Approvals.length > 0) {

//         setApprovedTableData(Approvals)

//       }
//       else {
//         setApprovedTableData([]);

//       }

//     })
//   }

//   const changeWeek = (direction) => {
//     const newDates = [...selectedDates];
//     const increment = direction === "next" ? 7 : -7;

//     newDates[0] = new Date(
//       newDates[0].getTime() + increment * 24 * 60 * 60 * 1000
//     );
//     newDates[1] = new Date(newDates[0].getTime() + 6 * 24 * 60 * 60 * 1000);

//     setSelectedDates(newDates);
//     handleWeekSelection(newDates);
//   };
//   const isSameDayMonthYear = (date1, date2) => {
//     return (
//       date1.getDate() === date2.getDate() &&
//       date1.getMonth() === date2.getMonth() &&
//       date1.getFullYear() === date2.getFullYear()
//     );
//   };

//   function getDateInTimeZone(date = new Date(), timeZone = "UTC") {
//     const formatter = new Intl.DateTimeFormat("en-CA", {
//       timeZone,
//       year: "numeric",
//       month: "2-digit",
//       day: "2-digit",
//     });
//     const parts = formatter.formatToParts(date);
//     const year = parts.find(p => p.type === "year").value;
//     const month = parts.find(p => p.type === "month").value;
//     const day = parts.find(p => p.type === "day").value;
//     return `${day}-${month}-${year}`;
//   }

//   function isSameOrBeforeDay(date2Str, timeZone = "UTC") {
//     if (!date2Str) return false;
//     const [day, month, year] = date2Str.split("-");
//     if (!day || !month || !year) return false;

//     // Parse the input date string into a Date object in the specified timezone
//     const date2 = new Date(`${year}-${month}-${day}T00:00:00Z`);

//     // Get today's date in the specified timezone
//     const todayParts = getDateInTimeZone(new Date(), timeZone).split("-");
//     const [todayDay, todayMonth, todayYear] = todayParts;
//     const todayDate = new Date(`${todayYear}-${todayMonth}-${todayDay}T00:00:00Z`);
//     console.log(todayDate < date2, todayDate, date2, "todayISO")

//     return todayDate < date2;
//   }

//   const isSameDaydisable = (date1, date2) => {
//     if (date1 && date2) {
//       const parsedDate1 = dayjs(date1, "DD-MM-YYYY");
//       const parsedDate2 = dayjs(date2, "DD-MM-YYYY");
//       return parsedDate1.isBefore(parsedDate2);
//     }
//   };
//   const formatTimes = (totalMinutes) => {
//     if (isNaN(totalMinutes) || totalMinutes == null) return "00:00"; // Handle NaN or null
//     const hours = Math.floor(totalMinutes / 60);
//     const minutes = totalMinutes % 60;
//     return `${hours.toString().padStart(2, "0")}:${minutes
//       .toString()
//       .padStart(2, "0")}`;
//   };

//   const totalRow = useMemo(() => {
//     const newTotals = new Array(7).fill(0); // Assuming 7 days/columns

//     // Iterate through the table data
//     tableData?.forEach((row) => {
//       row?.days?.forEach((day, dayIndex) => {
//         // Corrected the spelling and used the dayIndex
//         day?.WorkItems?.forEach((workitem) => {
//           // Corrected the spelling of WorkItems
//           newTotals[dayIndex] += parseInt(workitem["task_hours"] || 0, 10); // Parse task-hours as an integer
//         });
//       });
//     });
//     return {
//       Project_id: "null",
//       Project_name: "Total",
//       employee_id: localStorage.getItem("employee_id"),
//       days: newTotals.map((total) => ({ task_hours: total })),
//     };
//   }, [tableData]);

//   const totalRowfirst = {
//     Project_id: "null",
//     Project_name: "Select a Task",
//     employee_id: localStorage.getItem("employee_id"),
//     days: Array(7).fill({ task_hours: 0 }),
//   };

//   const HandleModelopen = () => {

//   }

//   const columns = useMemo(
//     () => [
//       {
//         accessorKey: "client_name",
//         header: "Project",
//         size: 150,
//         Cell: ({ row, dayIndex }) => {
//           let isPastDate = false;

//           const projectDate = formatDateToDDMMYYYY(new Date(selectedDates[0]))

//           if (projectDate) {
//             isPastDate = dayjs(projectDate).isBefore(dayjs('2025-04-28'), 'day');
//           }



//           console.log(projectDate, isPastDate, 'projectDate')
//           const isTotalRow =
//             row.original.Project_name == "Total" ||
//             row.original.Defaults === "1";
//           console.log(
//             row?.original?.days?.[0]?.WorkItems?.[0]?.["Status"],
//             "row.original"
//           );

//           return isTotalRow ? (
//             <Input
//               className="w-[150px] timsheet-input"
//               value={
//                 row?.original?.days?.[0]?.WorkItems?.length > 0
//                   ? row?.original?.days?.[0]?.WorkItems?.[0]?.ItemName
//                   : row.original.Project_name
//               }
//               disabled={row.original.Project_name != "Select a Task"}
//               onClick={handleAddRow}
//               style={{
//                 color:
//                   row.original.Project_name == "Select a Task"
//                     ? "rgb(58 130 247)"
//                     : "black",
//               }}
//             />
//           ) : row.original.Project_name == "Select a Task" ? (
//             <div className="relative">




//               <Input
//                 className="w-[150px] text-[#3b82f6] timsheet-input hover:underline"
//                 value={"Select a task"}
//                 onClick={(e) => {
//                   if (!isPastDate) {
//                     handleCellClick(e, row);
//                   }
//                 }}
//                 style={{
//                   // color: isPastDate ? "gray" : "#3b82f6",
//                   boxShadow: "none",
//                   cursor: isPastDate ? "not-allowed" : "pointer",
//                   pointerEvents: isPastDate ? "none" : "auto",
//                   backgroundColor: isPastDate ? "#f5f5f5" : "white", // Optional: light gray background when disabled
//                 }}

//               />
//             </div>

//           ) : (
//             row.original.Defaults == "0" && (() => {
//               // const projectDate = row?.original?.days?.[0]?.date;
//               // const isPastDate = projectDate ? dayjs(projectDate).isBefore(dayjs(), 'day') : false;

//               return (
//                 <div
//                   onClick={(e) => {
//                     console.log(isPastDate, row?.original?.days?.[0]?.WorkItems?.[0]?.["Status"], "STATUS DATE");
//                     if (!isPastDate && (row?.original?.days?.[0]?.WorkItems?.[0]?.["Status"] ? row?.original?.days?.[0]?.WorkItems?.[0]?.["Status"] == 1 : true)) {

//                       handleCellClick(e, row);
//                     }
//                   }}
//                   style={{
//                     cursor: isPastDate ? 'not-allowed' : 'pointer',
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: isPastDate ? 'gray' : 'inherit',
//                     }}
//                   >
//                     {/* {row?.original?.days?.[0]?.WorkItems?.length > 0
//                       ? ((row.original.Project_name === row?.original?.days?.[0]?.WorkItems?.[0]?.ItemName) ? row.original.Project_name : `${row.original.Project_name} / ${row?.original?.days?.[0]?.WorkItems?.[0]?.ItemName}`)
//                       : row.original.Project_name || "Select Project"} */}

//                     {(() => {
//                       const wi = row?.original?.days?.[0]?.WorkItems?.[0];
//                       const parts = [row.original.Project_name];
//                       if (wi?.Track_Name) parts.push(wi.Track_Name);
//                       if (wi?.Module_Name) parts.push(wi.Module_Name);

//                       // if (wi?.ItemName) parts.push(`Task - ${wi.ItemName}`);

//                       if (wi?.ItemName) {
//   const ticketId = wi?.Ticket_id ? String(wi.Ticket_id).trim() : "";
//   const ticketIsValid = ticketId.toLowerCase().startsWith("#inc-");
//   const nameAlreadyHasTicket = wi.ItemName.trim().toLowerCase().startsWith("#inc-");
//   const taskLabel = ticketIsValid && !nameAlreadyHasTicket
//     ? `Task - ${ticketId} ${wi.ItemName}`
//     : `Task - ${wi.ItemName}`;
//   parts.push(taskLabel);
// }
//                       return parts.join(' / ');
//                     })()}




//                   </span>
//                 </div>
//               );
//             })()

//           );
//         },
//       },


//       ...dateList.map((date, index) => ({
//         accessorKey: date.accessorKey,
//         header: date.header,
//         size: 120,
//         Cell: ({ row }) => {
//           const rowIndex = row.index;
//           const dayIndex = index;
//           const dateForCell = row.original?.days?.[dayIndex]?.date || null;
//           let expireDate = row?.original?.Expire_Date || null;
//           const formattedDateForCell = dateForCell ? dayjs(dateForCell).format("DD-MM-YYYY") : null;
//           const formattedExpireDate = expireDate ? dayjs(expireDate).format("DD-MM-YYYY") : null;
//           const formattedDateForCelldisble = isSameDaydisable(dayjs().startOf('day'), formattedDateForCell);

//           const isExpired = formattedExpireDate != null && isSameOrBeforeDay(formattedExpireDate);

//           const isExpireitems = row.original.days?.[dayIndex].WorkItems?.[0]?.["Emp_Task_Status"] == 1;
//           const isProjectNameValid = row.original.Project_name !== "Total" && row.original.Project_name !== "Select a Task";
//           const isDisabled = !isProjectNameValid;
//           const currentMinutes = row.original.days?.[dayIndex].WorkItems?.[0]?.["task_hours"] || 0;
//           const formattedTime = formatTime(currentMinutes);
//           const task_Id = row.original.days?.[0].WorkItems?.[0]?.["ItemId"] || 0;
//           const Status = row.original.days?.[0].WorkItems?.[0]?.["Status"] == 0 ? true : false;

//           const Project_Status = row?.original?.Project_Status || null;

//           console.log("formattedDateForCelldisble", Project_Status, isExpireitems)
//           return (
//             <>
//               {row.original.Project_name == "Select a Task" ? (
//                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                   <DemoContainer
//                     components={["TimeField", "TimeField", "TimeField"]}
//                   >
//                     <Tooltip
//                       placement="leftTop"
//                       title="Select a task or add a new task."
//                       arrow={mergedArrow}
//                     >
//                       <TimeField
//                         className="custom_time"
//                         value={
//                           row.original.Project_name !== "Total"
//                             ? formattedTime
//                             : formatTime(
//                               row.original.days?.[dayIndex]?.["task_hours"]
//                             )
//                         }
//                         disabled={true} //|| (row?.original?.Expire_Date && !isSameDaydisable(row?.original?.Expire_Date, row?.original?.Expire_Date)) row.original.Project_name === 'Total'|| row.original.Project_name == "Select a Task"  ||    || (weekapproved == 1 && localStorage.getItem("emp_role_id") == 1)
//                         format="HH:mm"
//                       />
//                     </Tooltip>
//                   </DemoContainer>
//                 </LocalizationProvider>
//               )
//                 : (isExpired != null && formattedExpireDate != null && !isExpired && row.original.Project_name != "Total") || (Project_Status != null && Project_Status != 1 || isExpireitems && row.original.Project_name != "Total") ? (
//                   <LocalizationProvider dateAdapter={AdapterDayjs}>
//                     <DemoContainer
//                       components={["TimeField", "TimeField", "TimeField"]}
//                     >
//                       <Tooltip
//                         placement="leftTop"
//                         title={!isExpired ? "Project date is Expired." : Project_Status != 1 ? "Project is  Closed" : isExpireitems ? "Task is Removed " : ""}
//                         arrow={mergedArrow}
//                       >
//                         <TimeField
//                           className="custom_time"
//                           value={
//                             row.original.Project_name !== "Total"
//                               ? formattedTime
//                               : formatTime(
//                                 row.original.days?.[dayIndex]?.["task-hours"]
//                               )
//                           }
//                           disabled={Status || formattedDateForCelldisble || isDisabled || isExpireitems || !isExpired}
//                           format="HH:mm"
//                           onChange={(newValue) => {
//                             const formattedValue = `${newValue.hour()}:${newValue.minute()}`;
//                             handleInputChange(rowIndex, dayIndex, formattedValue);
//                           }}
//                         />
//                       </Tooltip>
//                     </DemoContainer>
//                   </LocalizationProvider>
//                 )
//                   : (
//                     !Loading &&
//                     tableData.length > 0 && (
//                       <>
//                         <LocalizationProvider dateAdapter={AdapterDayjs}>
//                           <DemoContainer
//                             components={["TimeField", "TimeField", "TimeField"]}
//                           >
//                             <TimeField
//                               className="custom_time"
//                               value={
//                                 row.original.Project_name !== "Total"
//                                   ? formattedTime
//                                   : formatTime(
//                                     row.original.days?.[dayIndex]?.[
//                                     "task_hours"
//                                     ] || 0
//                                   )
//                               }
//                               readOnly={true}
//                               disabled={
//                                 (formattedExpireDate != null && !isExpired) ||
//                                 Status ||
//                                 formattedDateForCelldisble ||
//                                 row.original.Project_name === "Total" ||
//                                 row.original.Project_name == "Select a Task" ||
//                                 (row?.original?.Approved_status &&
//                                   row?.original?.Approved_status == 1 &&
//                                   localStorage.getItem("emp_role_id") == 1) ||
//                                 isDisabled
//                               }
//                               format="HH:mm"

//                               onClick={() => (row.original.Defaults == 0) && showModal(
//                                 task_Id,
//                                 rowIndex,
//                                 dayIndex,
//                                 formatTime(row.original.days?.[dayIndex]["WorkItems"][0]?.["task_hours"] || 0),
//                                 row.original.days?.[dayIndex]["WorkItems"][0]?.["task_hours"],
//                                 row.original.days?.[dayIndex]["WorkItems"][0]?.["ItemName"],
//                                 row.original.days?.[dayIndex]["date"],
//                                 row.original
//                               )}

//                             />
//                           </DemoContainer>
//                         </LocalizationProvider>
//                       </>
//                     )
//                   )}
//             </>
//           );
//         },
//       })),



//       {
//         accessorKey: "Total",
//         header: "WeekTotal",
//         size: 100,
//         Cell: ({ row, index }) => {
//           const isTotalRow =
//             row.original.Project_name === "Total" ||
//             row.original.Defaults === "1";
//           let weekTotalMinutes = 0;
//           if (
//             row.original.Project_name === "Total" ||
//             row.original.Project_name === "Select a Task"
//           ) {
//             weekTotalMinutes = row?.original?.days?.reduce((acc, day) => {
//               return acc + parseInt(day["task_hours"] || 0, 10);
//             }, 0);
//           } else {
//             weekTotalMinutes = row?.original?.days?.reduce((acc, day) => {
//               const dayTotal = day?.WorkItems?.reduce((dayAcc, workItem) => {
//                 return dayAcc + parseInt(workItem["task_hours"] || 0, 10);
//               }, 0);
//               return acc + dayTotal;
//             }, 0);
//           }
//           // Format the total time in HH:mm
//           const formattedWeekTotal = formatTimes(weekTotalMinutes);
//           return (
//             <>
//               <label
//                 className="w-[150px] timesheet-input"
//                 style={{ color: "black" }}
//               >
//                 {formattedWeekTotal}
//               </label>
//             </>
//           );
//         },
//       },
//       // {
//       //   accessorKey: "actions",
//       //   header: "Actions",
//       //   size: 100,
//       //   Cell: ({ row }) => {
//       //     const isTotalRow =
//       //       row.original.Project_name === "Total" ||
//       //       row.original.Defaults === "1";
//       //     return isTotalRow ||
//       //       row.original.Project_name == "Select a Task" ? null : (
//       //       <div className="text-center">
//       //         <Tooltip title="Delete">
//       //           { }
//       //           <IconButton
//       //             onClick={() => handleDeleteRow(row.index, row)}
//       //             disabled={
//       //               row?.original?.Approved_status &&
//       //               row?.original?.Approved_status == 1 &&
//       //               localStorage.getItem("emp_role_id") == 1
//       //             }
//       //             size="small"
//       //             style={{ color: "red" }}
//       //           >
//       //             <i class="fa fa-trash"></i>
//       //           </IconButton>
//       //         </Tooltip>
//       //       </div>
//       //     );
//       //   },
//       // },
//     ],
//     [dateList, tableData, treeData, handleCellClick]
//   );

//   const handleclick = async (values, data) => {
//     let rowIndex = 0;
//     let transformed = {
//       triggerNode: {
//         props: {
//           ...data,
//           disabled: true,
//         },
//       },
//     };
//     // handleSelectChangeselect(row.index, 'project', e, extra); setTasklists(1)
//     console.log(values, transformed);
//     await handleAddRow(rowIndex, "Project", data.value, transformed);
//     setDropdownPosition(null);
//     setActiveRowIndex(null);
//     // if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
//     //   setDropdownPosition(null);
//     //   setActiveRowIndex(null);
//     // }
//   };

//   const handleclickchange = async (index, values, data) => {
//     let transformed = {
//       triggerNode: {
//         props: {
//           ...data,
//         },
//       },
//     };

//     console.log(values, tableData[index], "HELLO");



//     const row = tableData[index]; // this is an array

//     let transformedTableData = [];

//     // Get project status at index 8
//     const hasProjectStatus = row.Project_Status != 1;

//     // Get days array at index 10
//     const hasTaskStatus = Array.isArray(row.days) && row.days.some(day => day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 1));

//     // If either condition is true, mark this row
//     if (hasProjectStatus || hasTaskStatus) {
//       console.log(hasProjectStatus, hasTaskStatus, "hasTaskStatus")
//       transformedTableData.push(row);
//     }

//     if (transformedTableData.length > 0) {
//       console.log(transformedTableData, "Matching item found — exiting function early");
//       return;
//     }
//     await handleSelectChange(index, transformed, data.value, 0);
//     setDropdownPosition(null);
//     setActiveRowIndex(null);
//   };




//   // const HandleSearch = (value) => {
//   //   console.log("Search value:", value);

//   //   const filtered = search.map(item => {
//   //     const filteredChildren = item.children?.filter(child =>
//   //       child.project_name?.toLowerCase().includes(value.toLowerCase())
//   //     );

//   //     return {
//   //       ...item,
//   //       children: filteredChildren
//   //     };
//   //   }).filter(item => item.children && item.children.length > 0);
//   //   console.log("Filtered data:", filtered);

//   //   settreeData(filtered);
//   // };

//   const HandleSearch = (value) => {
//   console.log("Search value:", value);

//   const lowerVal = value.toLowerCase();

//   const filtered = search.map(item => {
//     const filteredChildren = item.children?.filter(child => {
//       const matchesName = child.project_name?.toLowerCase().includes(lowerVal);
//       const ticketId = child.Ticket_id ? String(child.Ticket_id).trim().toLowerCase() : "";
//       const matchesTicket = ticketId.startsWith("#inc-") && ticketId.includes(lowerVal);
//       return matchesName || matchesTicket;
//     });

//     return {
//       ...item,
//       children: filteredChildren
//     };
//   }).filter(item => item.children && item.children.length > 0);

//   console.log("Filtered data:", filtered);
//   settreeData(filtered);
// };


//   const renderDropdown = () => {
//     if (!dropdownPosition || activeRowIndex === null) return null;

//     const row = tableData[activeRowIndex];
//     // if (!row || row.Defaults !== '0') return null;

//     console.log(row, "dropdownPosition");

//     return createPortal(
//       <div
//         ref={dropdownRef}
//         className="custom-dropdown_box bg-white shadow-lg border"
//         style={{
//           position: "absolute",
//           top: dropdownPosition.top,
//           left: dropdownPosition.left,
//           width: `${size.width}px`,
//           height: `${size.height}px`,
//           zIndex: 1000,
//         }}
//       >
//         <div className="draggabe_box relative">
//           <div className="px-[18px]">
//             <Search
//               placeholder="Search project or client"
//               className="w-full task-select"
//               allowClear
//               onChange={(e) => { HandleSearch(e.target.value) }}
//               onSearch={() => { console.log('search') }}
//             />
//           </div>

//           <div className="my-3">
//             <div className="flex items-center justify-between text-xs text-gray-500 font-medium mb-2 px-[20px]">
//               <p className="text-[12px]">Tasks</p>
//               <div
//                 className="flex items-center gap-1 cursor-pointer"
//                 onClick={handleListToggle}
//               >
//                 <p>{`${treeData.length} ${treeData.length <= 1 ? ('task') : ('tasks')}`}</p>
//                 {isListExpanded ? (
//                   <IoIosArrowUp className="text-[15px]" />
//                 ) : (
//                   <IoIosArrowDown className="text-[15px]" />
//                 )}
//               </div>
//             </div>
//             {
//               dropdownLoad ? (
//                 <Skeleton active className="px-[20px]" />
//               ) : (
//                 treeData.length <= 0 ? (
//                   <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Task" />
//                 ) : (
//                   isListExpanded && (
//   <ul className="text-sm mt-3">
//     {treeData.map((project, index) => {
//       const itemKey = `${project.key}-${index}`;
//       const isDisabled =
//         project?.children[0]?.disabled &&
//         project?.children[0]?.Item_status !== "Completed";
//       const isCompleted = project?.children[0]?.Item_status === "Completed";
//       const isTruncated = truncatedMap[itemKey];

//       const tooltipTitle = isTruncated
//         ? project.title
//         : isDisabled
//         ? "Already Selected"
//         : isCompleted
//         ? "Task Status is Completed"
//         : "Select a task";

//       return (
//   <React.Fragment key={itemKey}>
//     <Tooltip placement="bottom" title={tooltipTitle} arrow={mergedArrow} overlayStyle={{ maxWidth: "none" }}
//   overlayInnerStyle={{ whiteSpace: "nowrap" }}>
//       <li className="text-xs text-[#555]">
//         <div className="flex items-center justify-between w-full px-[20px]">
//           <button className="flex items-center gap-2 w-[85%] min-w-0">
//             <span className="w-2 h-2 rounded-full bg-purple-600 inline-block shrink-0"></span>
//             {React.cloneElement(project.title, {
//               ref: (el) => (itemRefs.current[itemKey] = el),
//               onMouseEnter: (e) => {
//                 const el = e.currentTarget;
//                 const truncated = el.scrollWidth > el.clientWidth;
//                 setTruncatedMap((prev) =>
//                   prev[itemKey] === truncated ? prev : { ...prev, [itemKey]: truncated }
//                 );
//               },
//               onClick: () => {
//                 if (isDisabled || isCompleted) return;
//                 row === undefined
//                   ? handleclick(project.title, project.children[0])
//                   : handleclickchange(activeRowIndex, project.title, project.children[0]);
//               },
//             })}
//           </button>
//         </div>
//       </li>
//     </Tooltip>
//   </React.Fragment>
// );
//     })}
//   </ul>
// )
//                 )
//               )
//             }


//             {/* {isListExpanded && (
//               <ul className="text-sm mt-3">
//                 {treeData.map((project, index) => (
//                   <React.Fragment key={`${project.key}-${index}`}>
//                     <Tooltip
//                       placement="leftTop"
//                       title={
//                         project?.children[0]?.disabled && project?.children[0]?.Item_status !== "Completed"
//                           ? "Already Selected"
//                           : project?.children[0]?.Item_status === "Completed"
//                             ? "Task Status is Completed"
//                             : "Select a task"
//                       }
//                       arrow={mergedArrow}
//                     >
//                       <li className="text-xs text-[#555]">
//                         <div className="flex items-center justify-between w-full px-[20px]">
//                           <button className="flex items-center gap-2 w-[85%]">
//                             <span className="w-2 h-2 rounded-full bg-purple-600 inline-block"></span>
//                             <p
//                               className="text-[#353535] w-[100%] truncate text-start"
//                               onClick={() => {
//                                 if (project?.children[0]?.disabled || project?.children[0]?.Item_status === "Completed") return;
//                                 row === undefined
//                                   ? handleclick(project.title, project.children[0])
//                                   : handleclickchange(activeRowIndex, project.title, project.children[0]);
//                               }}
//                             >
//                               {project.title}
//                             </p>
//                           </button>
//                         </div>
//                       </li>
//                     </Tooltip>
//                   </React.Fragment>
//                 ))}


//               </ul>
//             )} */}
//           </div>
//         </div>
//         <div
//           className="absolute bottom-[5px] right-[5px] cursor-se-resize"
//           onMouseDown={startResizing}
//         >
//           <img src="/resize.svg" alt="Resize" />
//         </div>
//       </div>,
//       document.getElementById("custom-dropdown-portal") || document.body
//     );
//   };

//   const AddTask = (value, data) => {

//     setTasklists(data[0]);
//     setIsModalVisible({ visible: true, name: `${data[0].Project_name} / Create task` });
//     setDropdownPosition(null);
//     setActiveRowIndex(null);

//     console.log(data, treeData, "DATA ON FORM");
//   };

//   const getclients = async () => {
//     const storedClientIds =
//       JSON.parse(localStorage.getItem("Emp_Assign_client")) || []; // Fetch data from the API
//     const response = await Timesheetapi.get(
//       `api/Projects/getProjManagerclients?empid=${localStorage.getItem(
//         "emp_role_id"
//       )}&clientid=${storedClientIds}`
//     );
//     const clientOptions = response.data.Client.filter((project) =>
//       storedClientIds.includes(project.Client_id)
//     )
//       .map((project) => ({
//         value: project.Client_id,
//         label: project.Client_name,
//       }))
//       .filter(
//         (item, index, self) =>
//           index === self.findIndex((t) => t.value === item.value)
//       );

//     setClient(clientOptions);
//   };

//   const getprojectList = async (client_id) => {
//     // setLoading(true);

//     const response = await Timesheetapi.get(
//       `api/projects/getRequirements?empid=${localStorage.getItem(
//         "employee_id"
//       )}&Role_Id=${5}&Client_id=${client_id}`
//     );
//     const memberOptions = response.data.Result.map((Team) => ({
//       value: Team.Project_id,
//       label: Team.projectname,
//     }));
//     setRequirements(memberOptions);
//   };

//   const handleTaskSubmit = async (values) => {
//     console.log("Values", values);

//     const now = new Date();
//     const formattedDateTime = now.toISOString().slice(0, 19).replace("T", " ");
//     let payload = {
//       Item_Id: 0,
//       Req_Id: 0,
//       Projectid: Tasklists.project_id,
//       clientid: Tasklists.client_id,
//       itemname: values.title,
//       itemtype: "Task",
//       assign_by: localStorage.getItem("employee_id"),
//       assign_to: localStorage.getItem("employee_id"),
//       item_sdate: formattedDateTime,
//       item_edate: formattedDateTime,
//     };

//     await Timesheetapi.post("api/Projects/addEmployeeWorkItem", payload).then(
//       async (response) => {
//         console.log("response", response?.data?.data);
//         if (response.data.status == 1) {
//           setLoading(true);
//           // await getprojectname(localStorage.getItem("employee_id"));
//           console.log(response.data.message, "Messagessss");
//           let rowIndex = 1;

//           let transformed = {
//             triggerNode: {
//               props: {
//                 value: response?.data?.data?.Item_Id,
//                 client_id: Tasklists.client_id,
//                 project_id: Tasklists.project_id,
//                 client_name: response?.data?.data?.Client_Name,
//                 Project_name: response?.data?.data?.Project_Name,
//                 Item_Name: values.title,
//                 project_name: values.title,
//                 Item_type: "Task",
//                 Item_status: "Active",
//                 "Item_Id:": response?.data?.data?.Item_Id,
//                 disabled: false,
//               },
//             },
//           };

//           console.log("transformed", transformed);
//           await handleAddRow(
//             rowIndex,
//             "Project",
//             response?.data?.data?.Item_Id,
//             transformed
//           );
//           message.success(
//             "Task successfully created and added to your workspace."
//           );
//           setLoading(false);
//           setIsModalVisible({ visible: false, name: '' });
//           form.resetFields();
//         }
//       }
//     ).catch((err) => {

//       const errorLog = {
//         Error_Message: err,
//         Stack_Trace: '',
//         Method_Name: `api/Projects/addEmployeeWorkItem`,
//         File_Name: 'Timesheet.js',
//         User_Id: localStorage.getItem("employee_id"),
//       };
//       ErrorLog(errorLog)
//     })
//   };


//   const HandleDeleteComments = async (e) => {
//     setIsDeletingComment(true);
//     console.log(e, "Values")
//     const commentId = e.content_Id;
//     const parsedChangeHours = dayjs(e.Changed_Hrs, "HH:mm");
//     const totalMinutes = parsedChangeHours.hour() * 60 + parsedChangeHours.minute();

//     // setIsLoadComments(true);
//     let subtraction = Time - totalMinutes

//     const finalTime = await formatTime(subtraction);
//     const parsedFinalTime = dayjs(finalTime, "HH:mm");

//     console.log("parsedFinalTime", finalTime)

//     await handleInputChange(taskId.rowIndex, taskId.dayIndex, parsedFinalTime.format("HH:mm"));

//     setTime(parseInt(subtraction))

//     const res = await Timesheetapi.post(`api/Projects/DeleteComments?comment_Id=${commentId}`);

//     if (res.data === "Success") {
//       const Res = await Timesheetapi.get(
//         `api/Projects/GetComments?empid=${localStorage.getItem("employee_id")}&role_id=${localStorage.getItem("employee_id")}&task_id=${taskId.task_Id}&&sdate=${taskId.task_Date}`);
//       setComments(Res?.data?.Comments);
//       await handlesubmit();

//       setchangehours(dayjs("00:00", "HH:mm"));
//       success("Updated successfully.");
//     }

//     setIsDeletingComment(false);


//   }

//   return (
//     <div className="w-full h-full flex justify-center">
//       <Box className="custom-material mt-[33px] ">
//         {contextHolder}
//         {contextHolder1}
//         <ToastContainer />
//         {!Loading ? (
//           <>
//             <div className="timesheet_custom_table timesheet_section">
//               <MaterialReactTable
//                 columns={columns}
//                 data={[...tableData, totalRowfirst, totalRow]}
//                 enableColumnActions={false}
//                 enableColumnFilters={false}
//                 enableFullScreenToggle={false}
//                 enableDensityToggle={false}
//                 enableColumnVisibility={false}
//                 enableSorting={false}
//                 enableGlobalFilter={false}
//                 enableHiding={false}
//                 enablePagination={false}

//                 muiTableHeadCellProps={{ sx: { backgroundColor: '#fff' } }}

//                 renderTopToolbarCustomActions={() => (
//                   <>
//                     <div className="flex items-center gap-3 justify-between w-full">
//                       <div className="flex items-center gap-3">
//                         <div className="flex items-center justify-between px-4">
//                           <span className="page-heading">ACTIVITY CARD</span>
//                         </div>

//                         {/* ✅ Project Cards */}
//                         {projectCards.length > 0 && (
//                           <div style={{
//                             display: 'flex',
//                             flexWrap: 'wrap',
//                             gap: '10px',
//                             width: '100%',
//                           }}>
//                             {projectCards.map((card, idx) => (
//                               <div
//                                 key={idx}
//                                 style={{
//                                   border: `2px solid ${card.color.border}`,
//                                   borderRadius: '8px',
//                                   backgroundColor: card.color.bg,
//                                   padding: '5px',
//                                   minWidth: '140px',
//                                   display: 'flex',
//                                   gap: '5px',
//                                   flexDirection: 'row',
//                                   alignItems: 'baseline',
//                                   justifyContent: 'center',
//                                   boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
//                                 }}
//                               >
//                                 <span style={{
//                                   fontSize: '11px',
//                                   fontWeight: '600',
//                                   color: '#555',
//                                   whiteSpace: 'nowrap',
//                                   overflow: 'hidden',
//                                   textOverflow: 'ellipsis',
//                                   maxWidth: '130px',
//                                 }} title={card.name}>
//                                   {card.name}
//                                 </span>
//                                 <span style={{
//                                   fontSize: '16px',
//                                   fontWeight: '700',
//                                   color: card.color.text,
//                                   marginTop: '',
//                                 }}>
//                                   {card.formatted}
//                                 </span>
//                               </div>
//                             ))}
//                           </div>
//                         )}
//                       </div>


//                       {/* Date picker — unchanged */}
//                       <div className="">
//                         <div className="flex items-start">
//                           <div className="custom-flatpicker">
//                             <Flatpickr
//                               className="date-picker"
//                               value={selectedDates}
//                               options={{
//                                 mode: "range",
//                                 dateFormat: "D, M j",
//                                 maxDate: selectedDate[1],
//                                 onChange: handleWeekSelection,
//                               }}
//                             />
//                           </div>
//                           <div
//                             className="custom-flatpicker"
//                             style={{ padding: "9px 10px 8px", borderLeft: "0px", cursor: "pointer" }}
//                             onClick={() => changeWeek("prev")}
//                           >
//                             <MdOutlineArrowBackIos className="text-[12px]" />
//                           </div>
//                           <div
//                             className="custom-flatpicker"
//                             onClick={() => {
//                               if (selectedDate[1] && selectedDates[1] && !isSameDayMonthYear(selectedDate[1], selectedDates[1])) {
//                                 changeWeek("next");
//                               }
//                             }}
//                             style={{
//                               padding: "9px 10px 8px",
//                               borderLeft: "0px",
//                               cursor: selectedDate[1] && selectedDates[1] && isSameDayMonthYear(selectedDate[1], selectedDates[1])
//                                 ? "not-allowed" : "pointer",
//                             }}
//                           >
//                             <MdOutlineArrowForwardIos className="text-[12px]" />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </>
//                 )}
//               />
//               {renderDropdown()}
//             </div>

//             <div className="mt-3">
//               <StatusTable
//                 tableData={approvedTableData}
//               />
//             </div>

//             <>
//               <Modal
//                 title={
//                   <>
//                     <ExclamationCircleFilled
//                       style={{ color: "orange", marginRight: "8px" }}
//                     />{" "}
//                     Confirm
//                   </>
//                 }
//                 visible={isModalOpen}
//                 onOk={confirmDelete}
//                 onCancel={cancelDelete}
//                 footer={[
//                   <Button key="cancel" onClick={cancelDelete}>
//                     Cancel
//                   </Button>,
//                   <Button key="confirm" type="primary" onClick={confirmDelete}>
//                     Delete
//                   </Button>,
//                 ]}
//               >
//                 <p>Are you sure you want to delete this row?</p>
//               </Modal>
//             </>

//             <>
//               <Modal
//                 className="workitem-popup"
//                 title={isModalVisible.name}
//                 open={isModalVisible.visible}
//                 onOk={toggleModal}
//                 onCancel={toggleModal}
//                 footer={null}
//               >
//                 <div className="bg-white rounded-lg">
//                   <Form
//                     form={form}
//                     onFinish={handleTaskSubmit}
//                     layout="vertical"
//                   >
//                     {/*  */}
//                     <div className="grid grid-cols-1 gap-x-4">
//                       <div>
//                         <Form.Item
//                           label={`Title`}
//                           name="title"
//                           placeholder="Please select"
//                           rules={[
//                             { required: true, message: "Enter the title" },
//                           ]}
//                         >
//                           <Input className="h-10"></Input>
//                         </Form.Item>
//                       </div>
//                     </div>

//                     <Form.Item className="text-right footer-form-item">
//                       <Button
//                         type="default"
//                         onClick={toggleModal}
//                         style={{ marginRight: "8px" }}
//                       >
//                         Cancel
//                       </Button>
//                       <Button type="primary" htmlType="submit">
//                         Create
//                       </Button>
//                     </Form.Item>
//                   </Form>
//                 </div>
//               </Modal>
//             </>

//             {weekapproved == "1" && localStorage.getItem("emp_role_id") == 1 ? (
//               <div
//                 className="flex items-center gap-[20px]"
//                 style={{
//                   justifyContent: "end",
//                   position: "relative",
//                   right: "1rem",
//                   top: "-3.1rem",
//                 }}
//               >
//                 <Button
//                   className="approve-btn bg-blue-500 text-white py-1.5 px-3 rounded flex items-center relative top-[4px] z-[9] left-[10px]"
//                 //onClick={handlesubmit}
//                 >
//                   Weekly approved success
//                 </Button>
//               </div>
//             ) : (
//               <div
//                 className="flex items-center gap-[20px]"
//                 style={{
//                   justifyContent: "end",
//                   position: "relative",
//                   right: "1rem",
//                   top: "-3.1rem",
//                 }}
//               >
//                 {/* <Button
//                   className="approve-btn bg-blue-500 text-white py-1.5 px-3 rounded flex items-center relative top-[4px] z-[9] left-[10px]"
//                   onClick={handlesubmit}
//                 >
//                   {localStorage.getItem("emp_role_id") == 1
//                     ? " SUBMIT FOR APPROVAL"
//                     : " SAVE AND SUBMIT"}
//                 </Button> */}
//               </div>
//             )}
//           </>
//         ) : (
//           <>
//             <Spin tip="Loading...">
//               <MaterialReactTable
//                 columns={columns}
//                 data={[...tableData, totalRowfirst, totalRow]}
//                 enableColumnActions={false}
//                 enableColumnFilters={false}
//                 enableFullScreenToggle={false}
//                 enableDensityToggle={false}
//                 enableColumnVisibility={false}
//                 enableSorting={false}
//                 enableGlobalFilter={false}
//                 enablePagination={false}
//               />
//               {renderDropdown()}
//             </Spin>
//           </>
//         )}
//       </Box>


//       <Modal
//         className="custom-project_modal"
//         title={`${taskId?.task_Name}  |  ${taskId?.task_Date && convertToDDMMYYYY(taskId?.task_Date)}`}
//         open={isProjectModalOpen}
//         closable
//         maskClosable={false}
//         keyboard={false}
//         footer={false}
//         onCancel={!isLoadComments && !isDeletingComment ? handleCancel : undefined}
//       >

//         <div>
//           {/* Task Description and Billing Status Section */}
//           {(taskId?.task_Description || taskId?.Billing_Status) && (
//             <div style={{ border: '1px solid #e8e8e8', padding: '12px', borderRadius: '5px', marginBottom: '15px', backgroundColor: '#fafafa' }}>
//               {taskId?.task_Description && (
//                 <div style={{ marginBottom: '10px' }}>
//                   <p style={{ fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '5px' }}>Task Description</p>
//                   <div style={{ fontSize: '13px', color: '#666', backgroundColor: '#fff', padding: '8px', borderRadius: '3px', minHeight: '40px' }}>
//                     {taskId.task_Description}
//                   </div>
//                 </div>
//               )}
//               {taskId?.Billing_Status && (
//                 <div>
//                   <p style={{ fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '5px' }}>Billing Status</p>
//                   <span style={{
//                     fontSize: '12px',
//                     fontWeight: '500',
//                     padding: '4px 10px',
//                     borderRadius: '3px',
//                     backgroundColor: taskId.Billing_Status === 'billable' ? '#d4edda' : '#fff3cd',
//                     color: taskId.Billing_Status === 'billable' ? '#155724' : '#856404'
//                   }}>
//                     {taskId.Billing_Status === 'billable' ? 'Billable' : taskId.Billing_Status === 'non-billable' ? 'Non-Billable' : taskId.Billing_Status}
//                   </span>
//                 </div>
//               )}
//             </div>
//           )}

//           <div style={{ border: '1px solid #cccccc', padding: '10px', borderRadius: '5px' }}>
//             <div className="quill_wrapper">
//               <div className="w-[100%]">
//                 <p className="text-[13px] text-[#555] font-[600] mb-2">What did you do today?</p>
//                 <TextArea classNames="input-comments" placeholder="Add your comments here." onChange={(e) => setInputComments(e.currentTarget.value)} value={inputComments} readOnly={isLoadComments || isDeletingComment} />
//               </div>

//             </div>
//             <div className="flex items-center gap-2 justify-end mt-3">
//               <div className="input_wrapper">
//                 <p className="text-[12px] text-[#555] font-[600]">{'Worked Hours (HH:MM) : '}</p>
//                 <div className="custom_hours">
//                   <LocalizationProvider dateAdapter={AdapterDayjs}>
//                     <DemoContainer
//                       components={["TimeField", "TimeField", "TimeField"]} >
//                       <TimeField
//                         className={`custom_time custom_time-field ${exceededCommentLimit ? 'custom_time-error-border' : ''}`}
//                         format="HH:mm"
//                         value={changehours}
//                         minTime={dayjs("00:00", "HH:mm")}
//                         onChange={(newValue) => {


//                           // If user clears or gives an invalid value
//                           if (!newValue || !dayjs(newValue).isValid() || newValue.isBefore(dayjs("00:00", "HH:mm"))) {
//                             console.log(newValue, "gytytt")
//                             setValue(dayjs(newValue).isValid())
//                             // setchangehours(dayjs("00:00", "HH:mm"));
//                           } else {
//                             setdeletedata(newValue.hour())
//                             setValue(dayjs(newValue).isValid())
//                             const formattedValue = newValue.format("HH:mm");
//                             const [hours, minutes] = formattedValue.split(":").map(Number);
//                             const enteredMins = hours * 60 + minutes;


//                             if (newValue.hour() && newValue.hour() > 0) {
//                               console.log("TYPE?", newValue.hour())
//                             }
//                             if ((enteredMins + taskId.current_Total) < 1440) {

//                               if (enteredMins <= 240) {
//                                 setExceededCommentLimit(false);
//                                 setchangehours(newValue);
//                                 return
//                               }
//                               else {
//                                 openNotification('Comment Hour Limit Exceeded', 'Max 4 hours allowed per comment');
//                                 setchangehours(newValue);
//                                 setExceededCommentLimit(true);
//                                 return
//                               }
//                             }
//                             else {
//                               setExceededCommentLimit(false);
//                               openNotification('Daily Hour Limit Exceeded', 'Max 24 hours allowed per day');
//                               setchangehours(dayjs("00:00", "HH:mm"));
//                               return
//                             }

//                           }
//                         }}
//                         disabled={isLoadComments || isDeletingComment}

//                       />


//                     </DemoContainer>
//                   </LocalizationProvider>
//                 </div>

//               </div>
//               <div className="flex items-center gap-1.5">
//                 <Button onClick={!isLoadComments && !isDeletingComment ? handleClear : undefined} className="h-[35px] px-[25px]" style={isLoadComments || isDeletingComment ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}>Clear</Button>
//                 <Button className="text-[#fff] bg-[#4096ff] h-[35px] px-[25px]" onClick={!isLoadComments && !isDeletingComment ? handleOk : undefined} style={isLoadComments || isDeletingComment ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}>{!isLoadComments ? 'Save' : 'Saving...'}</Button>
//               </div>
//             </div>

//           </div>

//           <div className="mt-4">

//             {/* <p className="text-[13px] text-[#555] font-[600]">Comments : </p> */}
//             {isLoadComments || isDeletingComment ? (

//               <Skeleton active />
//             ) : (
//               <div className="mt-1 mb-3">
//                 {Comments?.map((employee, empIndex) => (
//                   <div key={empIndex} className="comment-box">
//                     {employee.Comment_By_Date?.map((dateGroup, dateIndex) => (
//                       <div key={dateIndex} className="comment-child">
//                         <div className="flex justify-center">
//                           <div className="day_box">
//                             {checkDate(dateGroup.Date)}
//                           </div>

//                         </div>
//                         <p className="name-label">{employee.Emp_name} :</p>
//                         {dateGroup.Comments_Per_Day?.map((comment, commentIndex) => (
//                           <div key={commentIndex} className="mb-0">

//                             <div className="flex items-center justify-between mb-1">

//                             </div>

//                             <div className="flex items-start justify-between">
//                               <div className="flex items-baseline">
//                                 <p className="time-label flex items-center gap-1">
//                                   {comment?.Created
//                                     ? new Date(comment.Created + 'Z').toLocaleTimeString([], {
//                                       hour: '2-digit',
//                                       minute: '2-digit',
//                                       // second: '2-digit', 
//                                       hour12: true,
//                                     })
//                                     : "00:00"}
//                                 </p>

//                                 <p className="w-[10px]">:</p>
//                                 <p className="comment-text"
//                                   data-id={comment.content_Id}
//                                   data-raw={comment.Changed_Hrs}
//                                   dangerouslySetInnerHTML={{
//                                     __html: `${comment.content
//                                       .replace(/ /g, '&nbsp;')   // Convert spaces (optional)
//                                       .replace(/\n/g, '<br>')}`
//                                   }}
//                                 />
//                               </div>
//                               <div className="flex items-center gap-2 whitespace-nowrap">
//                                 <p className="hours-label">Hrs : </p>
//                                 <p className="hours-label">{comment.Changed_Hrs || "-"}</p>
//                                 {!isLoadComments && !isDeletingComment ?
//                                   (<Popconfirm
//                                     title="Delete the comment"
//                                     description="Are you sure to delete this comment?"
//                                     icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
//                                     onConfirm={() => HandleDeleteComments(comment)}
//                                     okText="Yes"
//                                     cancelText="No"
//                                   >
//                                     <Button variant="link" color="danger" style={{ padding: '0px' }}> <DeleteOutlined /></Button>
//                                   </Popconfirm>)
//                                   : null
//                                 }

//                               </div>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     ))}
//                   </div>
//                 ))}
//               </div>
//             )}

//           </div>

//         </div>

//       </Modal>
//     </div >
//   );
// };


import React, { useEffect, useMemo, useState, useRef } from "react";
import { Box, IconButton } from "@mui/material";
import { ErrorLog } from "../common/ErrorLog";
import {
  Input,
  Select,
  Tag,
  message,
  Button,
  Spin,
  Modal,
  Tooltip,
  Form,
  notification,
  Popconfirm,
  Skeleton,
  Empty
} from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons';
import { LoadingOutlined } from '@ant-design/icons';
import { useMsal } from "@azure/msal-react";
import { useSearchParams } from "react-router-dom"; // [Dashboard link] read ?date=YYYY-MM-DD
import { MdOutlineArrowBackIos } from "react-icons/md";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { MaterialReactTable } from "material-react-table";
import { Timesheetapi } from "../../middleware/interceptor";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ExclamationCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { Activity_log } from "../../components/common/Activity_log";
import { GoBug } from "react-icons/go";
import { BiTask } from "react-icons/bi";
import { AiOutlineDelete } from "react-icons/ai";
import { AudioOutlined } from "@ant-design/icons";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { createPortal } from "react-dom";
import { ColorLens } from "@mui/icons-material";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TextArea from "antd/es/input/TextArea";
import { FiClock } from "react-icons/fi";
import { IoCalendarOutline } from "react-icons/io5";
import utc from "dayjs/plugin/utc";
import { DeleteOutlined } from '@ant-design/icons';
import StatusTable from "../sections/StatusTable";

const { Search } = Input;
const suffix = (
  <AudioOutlined
    style={{
      fontSize: 16,
      color: "#1677ff",
    }}
  />
);
const onSearch = (value, _e, info) =>
  console.log(info === null || info === void 0 ? void 0 : info.source, value);

export const Timesheet = ({ isAuthenticated, employee_id }) => {

  dayjs.extend(utc);
  const [approvedTableData, setApprovedTableData] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isListExpanded, setIsListExpanded] = useState(true);
  const dropdownRef = useRef(null);
  const [isResizing, setIsResizing] = useState(false);
  const [size, setSize] = useState({ width: 700, height: 250 });
  const [form] = Form.useForm();
  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentWeekDay = currentDate.getDay();
  const startOfWeek = new Date(currentDate);

  startOfWeek.setDate(
    currentDay - (currentWeekDay === 0 ? 6 : currentWeekDay - 1)
  );
  const today = new Date();

  // ── [Dashboard link] "Fill now" opens /timesheets?date=YYYY-MM-DD ──
  // Open that date's week instead of the current week, and highlight that day's column.
  const [searchParams] = useSearchParams();
  const focusDate = useMemo(() => {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(searchParams.get("date") || "");
    if (!m) return null;
    const d = new Date(+m[1], +m[2] - 1, +m[3]); // local date, no UTC shift
    return Number.isNaN(d.getTime()) || d > today ? null : d; // ignore bad / future dates
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
  // Same format handleWeekSelection uses for column keys, e.g. "Tue, Oct 13"
  const focusColumnKey = focusDate
    ? focusDate.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })
    : null;
  const FOCUS_BG = "#FFF4EC";
  const FOCUS_BORDER = "#EA7A3A";
  const focusHeadCellProps = ({ column }) => ({
    sx: column?.id === focusColumnKey
      ? { backgroundColor: FOCUS_BG, color: "#9A3412", fontWeight: 700, borderTop: `3px solid ${FOCUS_BORDER}` }
      : { backgroundColor: "#fff" },
  });
  const focusBodyCellProps = ({ column }) =>
    column?.id === focusColumnKey
      ? { sx: { backgroundColor: FOCUS_BG, borderLeft: `2px solid ${FOCUS_BORDER}`, borderRight: `2px solid ${FOCUS_BORDER}` } }
      : {};

  const [selectedDates, setSelectedDates] = useState([]);
  const { instance } = useMsal();
  const activeAccount = instance?.getActiveAccount();
  const name = activeAccount?.name || "";

  const [tableData, setTableData] = useState([]);
  const [temptableData, settempTableData] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  const [defaultvalue, setdefaultvalue] = useState("ME");
  const [weekapproved, setweekapproved] = useState("0");
  const [changehours, setchangehours] = useState(dayjs());
  const [Tasklists, setTasklists] = useState();
  const [tempoptions, settemoptions] = useState([]);
  const [project, setProject] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [arrow, setArrow] = useState("Show");
  const [treeData, settreeData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [timesheet_id, setTimesheet_id] = useState();
  const [dateList, setDateList] = useState([]);
  const [pendingAction, setPendingAction] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [deletedata, setdeletedata] = useState();
  const [totalRowCount, setTotalRowCount] = useState(new Array(7).fill(0)); // Initialize an array for 7 columns
  const [search, setsearch] = useState([]);
  const [value, setValue] = useState();
  const [workItemList, setWorkItemList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [Clients, setClient] = useState([]);
  const [Requirements, setRequirements] = useState([]);
  const [dropdownPosition, setDropdownPosition] = useState(null);
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const cellRef = useRef(null);
  const [expandedProjects, setExpandedProjects] = useState([]);
  const [isExpandedProject, setIsExpandedProject] = useState(null);
  const [shouldDelete, setShouldDelete] = useState(false);
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [taskId, settaskid] = useState({});
  const [istDate, setIstDate] = useState('');
  const [Time, setTime] = useState();
  const [Comments, setComments] = useState();
  const [inputComments, setInputComments] = useState();
  const [isLoadComments, setIsLoadComments] = useState(false);
  const [backupdata, setbackupdata] = useState([]);
  const [isDeletingComment, setIsDeletingComment] = useState(false);
  const [dropdownLoad, setDropdownLoad] = useState(false);
  const [exceededCommentLimit, setExceededCommentLimit] = useState(false);
  const [changehour, setchangehour] = useState("00:00");
  const [api, contextHolder1] = notification.useNotification();
  const [expandedTask, setExpandedTask] = useState(null);
  const containerRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(true);
  const [projectTotals, setProjectTotals] = useState([]);
  const itemRefs = useRef({});
const [truncatedMap, setTruncatedMap] = useState({}); 


  const projectCards = useMemo(() => {
    const cardColors = [
      { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
      { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
      { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
      { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
      { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },
      { border: '#37a9ff', text: '#7388a2', bg: '#eff6ff' },

    ];

    const projectMap = {};

    tableData.forEach((row) => {
      // ✅ FIX: use == instead of === to handle both string '1' and number 1
      if (
        row.Defaults == '1' ||
        row.Project_name === 'Total' ||
        row.Project_name === 'Select a Task' ||
        !row.Client_name  // ✅ skip rows with no client name yet
      ) return;

      const projectName = row.Client_name;

      if (!projectMap[projectName]) {
        projectMap[projectName] = 0;
      }

      row.days?.forEach((day) => {
        day.WorkItems?.forEach((wi) => {
          projectMap[projectName] += parseInt(wi.task_hours || 0, 10);
        });
      });
    });

    return Object.entries(projectMap).map(([name, totalMins], index) => {
      const hours = Math.floor(totalMins / 60);
      const mins = totalMins % 60;
      // ✅ FIX: format as HH:MM like "4:25" not "4.25"
      const formatted = `${hours}:${String(mins).padStart(2, '0')}`;
      const color = cardColors[index % cardColors.length];
      return { name, formatted, color };
    });
  }, [tableData]);

  useEffect(() => {
  const newTruncatedMap = {};
  Object.keys(itemRefs.current).forEach((key) => {
    const el = itemRefs.current[key];
    if (el) {
      newTruncatedMap[key] = el.scrollWidth > el.clientWidth;
    }
  });
  setTruncatedMap(newTruncatedMap);
}, [treeData, isListExpanded]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      //  settreeData(search)
      console.log(dropdownRef.current, "REF DATA");
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownPosition(null);
        setActiveRowIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [search]);
  useEffect(() => {
    if (isLoadComments) {

      const totalMinutes = dayjs(changehours, "HH:mm").hour() * 60 + dayjs(changehours, "HH:mm").minute();
      setTime(prevTime => {
        const updatedTime = parseInt(prevTime) + parseInt(totalMinutes);
        console.log("Updated Time:", updatedTime);
        return updatedTime;
      });
    }

  }, [isLoadComments]);
  useEffect(() => {
    window.addEventListener("mousemove", resize);
    window.addEventListener("mouseup", stopResizing);
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [isResizing]);

  useEffect(() => {


    const func = async () => {
      if (shouldDelete) {
        await handlesubmit();
        setShouldDelete(false);
      }
    }

    func();
  }, [tableData, shouldDelete]);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.contentRect.width < 300) {
          setIsTruncated(true); // small size → truncate
        } else {
          setIsTruncated(false); // big size → full title
        }
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);
  useEffect(() => {
    // [Dashboard link] start on the missed day's week when ?date= is present
    const initialDate = focusDate || today;
    handleWeekSelection([initialDate]);
    const selectedDate = initialDate;
    const startOfWeek = new Date(selectedDate);
    const dayOfWeek = startOfWeek.getDay();
    const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    setSelectedDate([startOfWeek, endOfWeek]);
  }, []);

  useEffect(() => {
    if (
      selectedDates.length > 0 &&
      localStorage.getItem("employee_id") != undefined
    ) {
      gettimesheetdata();
      // const OldProjectList = oldProjectList();
      let startDate = formatDateToDDMMYYYY(new Date(selectedDates[0]));
      let endDate = formatDateToDDMMYYYY(new Date("2025-01-06"));
      let tree = transformToTreeData(workItemList);
      settreeData(tree);
      settemoptions(tree);
      setsearch(tree)
    }
  }, [selectedDates]);
  useEffect(() => {
    const selectedDate = today;
    const startOfWeek = new Date(selectedDate);
    const dayOfWeek = startOfWeek.getDay();
    const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
    if (isAuthenticated || sessionStorage.getItem("AdminLogin") == 'true') {

      if (localStorage.getItem("employee_id") != null && localStorage.getItem("employee_id") != undefined
      ) {
        getprojectname(localStorage.getItem("employee_id"), startOfWeek);
      }
    }
  }, [isAuthenticated, localStorage.getItem("employee_id")]);

  useEffect(() => {
    const itemIds =
      tableData?.flatMap((dayData) =>
        dayData.days?.flatMap((day) =>
          day.WorkItems?.map((workItem) => Number(workItem.ItemId))
        )
      ) || [];
    const updatedOptions = tempoptions.map((option) => {
      if (option.children) {
        const updatedChildren = option.children.map((child) => {
          const isDisabled = itemIds.includes(child.value);

          return {
            ...child,
            disabled: isDisabled || false,
          };
        });
        return {
          ...option,
          children: updatedChildren,
        };
      }
      return option;
    });
    settreeData(updatedOptions);
    setsearch(updatedOptions)
  }, [tempoptions, tableData]);

  useEffect(() => {
    let rowIndex = 0;
    if (pendingAction.length > 0) {
      handleSelectChange(
        rowIndex,
        pendingAction[0].extra,
        pendingAction[0].value,
        1
      );
    }
  }, [pendingAction]);
  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);


  const formatDateToDDMMYYYY = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // Format as yyyy-mm-dd
  };

  const formatDateToYYYYMMDD = (date) => {
    return dayjs(date).format("YYYY-MM-DD");
  };

  const convertDateTime = (utcDateStr) => {
    return dayjs.utc(utcDateStr).local(); // Returns a Day.js object in local time
  };

  function normalizeDate(input) {
    const isoFormat = /^\d{4}-\d{2}-\d{2}$/;
    const ddmmyyyyFormat = /^\d{2}-\d{2}-\d{4}$/;

    let dateObj;

    if (isoFormat.test(input)) {
      const [yyyy, mm, dd] = input.split("-").map(Number);
      dateObj = new Date(Date.UTC(yyyy, mm - 1, dd));
    } else if (ddmmyyyyFormat.test(input)) {
      const [dd, mm, yyyy] = input.split("-").map(Number);
      dateObj = new Date(Date.UTC(yyyy, mm - 1, dd));
    } else {
      const parsed = new Date(input);
      if (!isNaN(parsed)) {
        dateObj = new Date(Date.UTC(
          parsed.getFullYear(),
          parsed.getMonth(),
          parsed.getDate()
        ));
      } else {
        return null; // invalid
      }
    }

    const yyyy = dateObj.getUTCFullYear();
    const mm = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(dateObj.getUTCDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }
  const checkDate = (inputDateStr) => {
    const inputDate = new Date(inputDateStr);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    // Format to 'YYYY-MM-DD'
    const formatDate = (date) => date.toISOString().split('T')[0];

    const input = formatDate(inputDate);
    const todayStr = formatDate(today);
    const yesterdayStr = formatDate(yesterday);

    if (input === todayStr) {
      return "Today";
    } else if (input === yesterdayStr) {
      return "Yesterday";
    } else {
      // Return as "May 18"
      const options = { month: 'short', day: 'numeric' };
      return inputDate.toLocaleDateString('en-US', options);
    }
  };
  const openNotification = (message, description) => {
    api.warning({
      message,
      description,
      placement: 'topRight',
      key: 'single-instance-notification',
      duration: 2.5,
    });
  };

  const convertToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";

    const parts = dateStr.split("-");
    if (parts[0].length === 4) {
      const [year, month, day] = parts;
      return `${day}-${month}-${year}`;
    }
    if (parts[2].length === 4) {
      const [day, month, year] = parts;
      return `${day}-${month}-${year}`;
    } return dateStr;
  };

  const showModal = async (task_Id, rowIndex, dayIndex, Hours, actual, task_Name, task_Date, rowData) => {
    const workItem = rowData?.days?.[dayIndex]?.WorkItems?.[0];
    settaskid({
      task_Id: task_Id,
      rowIndex: rowIndex,
      dayIndex: dayIndex,
      Hours: actual,
      task_Name,
      task_Date,
      task_Description: workItem?.Task_Description || workItem?.ItemDescription || "",
      Billing_Status: workItem?.Billing_Status || "",
      current_Total: totalRow.days[dayIndex].task_hours,
      rowData
    })

    setInputComments('')

    setTime(parseInt(actual))
    // console.log(original, "oRIGINAL Hours")
    setchangehours(dayjs("00:00", "HH:mm"));

    await Timesheetapi.get(`api/Projects/GetComments?empid=${localStorage.getItem("employee_id")}&role_id=${localStorage.getItem("employee_id")}&task_id=${task_Id}&sdate=${task_Date}`).then((Res) => {
      setComments(Res?.data?.Comments);
      console.log(Res, "VNNVJN")
    }).catch((error) => {

      console.log(error);
    })
    setIsProjectModalOpen(true);
    setExceededCommentLimit(false);
  };

  const handleOk = async () => {
    const parsedChangeHours = dayjs(changehours, "HH:mm");
    if (!parsedChangeHours.isValid()) {
      error("Invalid time format.");
      return;
    }

    const formattedHours = parsedChangeHours.format("HH:mm");
    const totalMinutes = parsedChangeHours.hour() * 60 + parsedChangeHours.minute();

    const nowDateTime = dayjs().format("YYYY-MM-DD HH:mm:ss");

    if (exceededCommentLimit) {
      openNotification('Comment Hour Limit Exceeded', 'Max 4 hours allowed per comment');
      return;
    }

    if (!value || formattedHours === "00:00") {
      error("Fill the worked Hours.");
      return;
    }

    if (inputComments.trim() === "") {
      error("Fill the Comments.");
      return;
    }

    setIsLoadComments(true);

    const newComment = {
      Changed_Hrs: formattedHours,
      Created: nowDateTime,
      content: inputComments.replace(/ /g, '&nbsp;').replace(/\n/g, '<br>')
    };

    const payload = {
      task_Id: taskId.task_Id,
      Changed_date: normalizeDate(taskId.task_Date),
      comments_html: newComment.content,
      raw_comments: inputComments,
      commented_By_Id: localStorage.getItem("employee_id"),
      changed_hours: formattedHours,
    };

    console.log("payloadgenerated", payload)


    //For Change Log
    const tempData = taskId.rowData
    const beforeChanges = structuredClone(taskId.rowData);

    const Constant_Data = {
      client_Details: {
        client_Id: tempData.Client_id,
        client_Name: tempData.Client_name,
      },
      project_Details: {
        project_Id: tempData.Project_id,
        project_Name: tempData.Project_name,
      },
      task_Details: {
        task_Id: tempData.days?.[0]?.WorkItems?.[0]?.ItemId,
        task_Name: tempData.days?.[0]?.WorkItems?.[0]?.ItemName,
      },
      employee_Details: {
        employee_Id: tempData.Employee_id,
        emp_Name: name,
      },
    };

    const After_Changes = {
      ...structuredClone(taskId.rowData),
      days: taskId.rowData.days?.map((day, index) => {
        if (index !== taskId.dayIndex) return structuredClone(day);

        return {
          ...structuredClone(day),
          WorkItems: day.WorkItems?.map((workItem, idx) => {
            if (idx !== 0) return structuredClone(workItem);

            return {
              ...structuredClone(workItem),
              task_hours: String(
                parseInt(workItem.task_hours, 10) + formatTimeHHmm(payload.changed_hours)
              ),
            };
          }),
        };
      }),
    };

    const Changes_Done = {
      change_Summary: `Task hours have been updated from ${formatTimes(tempData.days?.[taskId.dayIndex]?.WorkItems?.[0]?.task_hours)} hrs to ${formatTimes(parseInt(tempData.days?.[taskId.dayIndex]?.WorkItems?.[0]?.task_hours, 10) + formatTimeHHmm(formattedHours))} hrs on ${formatTimeMMDDYYYY(tempData.days?.[taskId.dayIndex]?.date)}. The update was performed on ${formatTimeWithUserTimezone()}, by ${name}.`,
      change_For_Date: taskId.task_Date,
      change_On_Date: formatDateToYYYYMMDD(new Date().toISOString()),
      change_Time: convertDateTime(new Date().toISOString()),
      Added_Comments: payload.raw_comments,
      Added_Comments_Html_Format: payload.comments_html,
    };

    // Final payload object
    const change_log = {
      Constant_Data,
      Before_Changes: beforeChanges,
      After_Changes,
      Changes_Done,
    };



    console.log("change_log", change_log)




    try {
      const addition = Time + totalMinutes;
      const finalTime = await formatTime(addition);
      const parsedFinalTime = dayjs(finalTime, "HH:mm");

      console.log(Time, totalMinutes, payload, "Console")
      await handleInputChange(taskId.rowIndex, taskId.dayIndex, parsedFinalTime.format("HH:mm"));

      const res = await Timesheetapi.post(`api/Projects/PutComments`, payload);

      if (res.data.status === "success") {
        const Res = await Timesheetapi.get(
          `api/Projects/GetComments?empid=${localStorage.getItem("employee_id")}&role_id=${localStorage.getItem("employee_id")}&task_id=${taskId.task_Id}&&sdate=${taskId.task_Date}`);
        setComments(Res?.data?.Comments);
        await handlesubmit();

        setchangehours(dayjs("00:00", "HH:mm"));
        success("Updated successfully.");
      }

    } catch (err) {
      console.error("❌ Failed to save comment:", err);
      error("Failed to save comment.");
    } finally {
      setInputComments('');
      setIsLoadComments(false);
    }
  };
  const handleClear = () => {
    setInputComments('')
    setchangehours(dayjs("00:00", "HH:mm"));
    setExceededCommentLimit(false);
  };

  const handleCancel = () => {
    setIsProjectModalOpen(false);
  };

  const handleCellClick = (event, row) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setDropdownPosition({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    });
    setActiveRowIndex(row.index);
  };

  const formatIst = (_Date) => {
    const date = new Date(_Date);

    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };

    const istString = date.toLocaleString('en-US', options); // e.g. "May 20, 2025, 07:44 PM"

    // Split full date and time
    const parts = istString.split(', '); // ["May 20", "2025", "07:44 PM"]

    return {
      date: `${parts[0]}, ${parts[1]}`, // "May 20, 2025"
      time: parts[2]                    // "07:44 PM"
    };
  };

  const handleToggle = (key) => {
    setIsExpandedProject((prev) => (prev === key ? null : key));
  };
  const handleListToggle = () => {
    setIsListExpanded(!isListExpanded);
  };

  const startResizing = (e) => {
    e.preventDefault();
    setIsResizing(true);
  };

  const stopResizing = () => {
    setIsResizing(false);
  };

  const resize = (e) => {
    if (isResizing && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const newWidth = e.clientX - rect.left;
      const newHeight = e.clientY - rect.top;

      setSize({
        width: Math.max(245, newWidth), // keeping min width
        height: Math.max(150, newHeight),
      });
    }
  };

  const toggleModal = () => {
    setIsModalVisible({ visible: false, name: '' });
    form.resetFields();
  };


  const success = (msg) => {
    messageApi.destroy();
    messageApi.open({
      type: "success",
      title: "Success",
      content: msg,
      duration: 1.5,
    });
  };
  const error = (msg) => {
    messageApi.destroy();
    messageApi.open({
      type: "error",
      duration: 1.5,
      content: msg,
    });
  };
  const warning = () => {
    messageApi.destroy();
    messageApi.open({
      type: "warning",
      title: "Warning",
      duration: 1.5,
      content: "No more project available",
    });
  };

  const handleToggleProject = (projectId) => {
    setExpandedProjects((prev) =>
      prev.includes(projectId)
        ? prev.filter((id) => id !== projectId)
        : [...prev, projectId]
    );
  };

  const getprojectname = async (username, date) => {
    // const OldProjectList = oldProjectList();
    //////  new change in implement Task udates ////////
    setDropdownLoad(true);
    const Tasklist = await Timesheetapi.get(
      `api/Projects/listWorkItemsOfEmployee?emp_id=${username}&&Role_id=${(localStorage.getItem('emp_role_id'))}`
    );

    console.log("First task sample:", Tasklist.data.Task_list[0]);
  console.log("Ticket_id values:", Tasklist.data.Task_list.map(t => ({ Item_id: t.Item_id, Item_Name: t.Item_Name, Ticket_id: t.Ticket_id })));
    setWorkItemList(Tasklist.data.Task_list);
    let startDate = formatDateToDDMMYYYY(new Date(date));
    let endDate = formatDateToDDMMYYYY(new Date("2025-01-06"));
    let tree = transformToTreeData(Tasklist.data.Task_list);

    settreeData(tree);
    setsearch(tree)

    console.log(tree, "task lists");
    settemoptions(tree);
    setDropdownLoad(false);
  };

  const handleDeleteRow = (rowIndex, row) => {
    setRowToDelete(rowIndex); // Set the row to delete
    setIsModalOpen(true);
    setdeletedata(row.original.Project_id);
  };

  const confirmDelete = async () => {
    // Filter out the row to delete
    setTableData((prevData) => {
      const newData = prevData.filter((_, index) => index !== rowToDelete);

      // Use the updated table data to set the disabled status
      const updatedOptions = tempoptions.map((option) => {
        const isDisabled = newData.some((item) => item.Project_id == option.id);
        return {
          ...option,
          disabled: isDisabled,
        };
      });
      setIsModalOpen(false);
      setRowToDelete(null);
      setProject(updatedOptions);

      return newData;
    });
    setShouldDelete(true);
  };

  const cancelDelete = () => {
    setIsModalOpen(false); // Close the modal without deleting
    setRowToDelete(null);
  };

  const handleAddRow = (rowIndex, field, value, extra) => {
    console.log("LogDATA", extra);

    // Accepts either a Date object or an ISO string like "2025-05-26"
    const parseLocalDate = (input) => {
      if (input instanceof Date) {
        return new Date(input.getFullYear(), input.getMonth(), input.getDate());
      }
      if (typeof input === "string" && input.includes("-")) {
        const [year, month, day] = input.split("-").map(Number);
        return new Date(year, month - 1, day);
      }
      throw new Error("Invalid input to parseLocalDate");
    };

    // Format a Date object to DD-MM-YYYY
    const formatDateToDDMMYYYY = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };

    const startDate = parseLocalDate(selectedDates[0]);
    const endDate = parseLocalDate(selectedDates[1]);

    const weekDates = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      weekDates.push(formatDateToDDMMYYYY(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    const daysArray = weekDates.map((date) => ({
      task_hours: 0,
      date: date,
    }));

    console.log(weekDates, "weekDates");

    let prodcm = [];

    if (prodcm.length <= project.length) {
      prodcm = [
        { project: "", task: "", Defaults: "0", days: daysArray },
        ...tableData,
      ];

      const projects = prodcm.filter((item) => item?.Defaults === "0");

      setTableData([{ Defaults: "0", days: daysArray }, ...tableData]);
      setPendingAction([
        {
          Defaults: "0",
          days: daysArray,
          rowIndex,
          field,
          value,
          extra,
        },
        ...tableData,
      ]);
    } else {
      toast.warning("No project available");
    }
  };

  const transformToTreeData = (Tasklists) => {
    const groupedData = {};

    // Group items by `Req_id` - filter out Sales items
    Tasklists.forEach((task) => {
      // Skip Sales items - they should not appear in activity card
      if (task.Item_type === "Sales") {
        return;
      }

      if (!groupedData[task.Item_id]) {
        groupedData[task.Item_id] = {
          // title: (
          //   <p className="font-mediums w-[100%] truncate text-[12px]">
          //     {/* {task.Client_name} - */}
          //     {task.Client_name} -  {task.Project_name} / {`Task - ${task.Item_Name}`}
          //   </p>
          // ),

          title: (
            <p className="font-mediums w-[100%] min-w-0 truncate text-[12px] text-left">
              {task.Client_name} - {task.Project_name}

              {/* ✅ Conditional Track / Module */}
              {(task.Track_Name || task.Module_Name) && (
                <> / {task.Track_Name || ""}{task.Module_Name ? ` / ${task.Module_Name}` : ""}</>
              )}


             {" / "}Task -{" "}
{(() => {
  const ticketId = task.Ticket_id ? String(task.Ticket_id).trim() : "";
  console.log("Ticket ID:", ticketId, "Item Name:", task.Item_Name); // Debug log
  const itemName = task.Item_Name || "";
  const ticketIsValid = ticketId.toLowerCase().startsWith("#inc-");
  const nameAlreadyHasTicket = itemName.trim().toLowerCase().startsWith("#inc-");
  return (
    <>
      {ticketIsValid && !nameAlreadyHasTicket && (
        <span className="font-medium mr-1">{ticketId}</span>
      )}
      {itemName}
    </>
  );
})()}


            </p>
          ),
          value: task.Project_id,
          key: task.Project_id,
          selectable: false,
          children: [],
        };
      }
      groupedData[task.Item_id].children.push({
        title: (
          <div className="flex items-center justify-between w-full pr-2">
            <span className="flex items-center gap-2">
              {task.Item_type === "Task" ? (
                <BiTask className="text-[#f3d138] text-[17px]" />
              ) : (
                <GoBug className="text-[red] text-[15px]" />
              )}
{/* 
              {"Task"} - {task.Item_Name} */}

              {"Task"} -{" "}
{(() => {
  const ticketId = task.Ticket_id ? String(task.Ticket_id).trim() : "";
  const itemName = task.Item_Name || "";
  const ticketIsValid = ticketId.toLowerCase().startsWith("#inc-");
  const nameAlreadyHasTicket = itemName.trim().toLowerCase().startsWith("#inc-");
  return (
    <>
      {ticketIsValid && !nameAlreadyHasTicket && (
        <span className="text-[#6b7280] font-medium mr-1">{ticketId}</span>
      )}
      {itemName}
    </>
  );
})()}


            </span>

            <Tooltip title="Delete Task">
              <AiOutlineDelete
                className="text-gray-400 hover:text-red-500 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  // handleDeleteTask(task.Item_id);
                }}
              />
            </Tooltip>
          </div>
        ),
        value: task.Item_id,
        key: task.Item_id,
        client_id: task.Client_id,
        project_id: task.Project_id,
        client_name: task.Client_name,
        Project_name: task.Project_name,
        Expire_Date: task.Project_End_Date,

        //project_name: task.Client_name + ' / ' + task.Project_name + ' / ' + `Task - ${task.Item_Name}`,


        project_name: (() => {
  const ticketId = task.Ticket_id ? String(task.Ticket_id).trim() : "";
  const itemName = task.Item_Name || "";
  const ticketIsValid = ticketId.toLowerCase().startsWith("#inc-");
  const nameAlreadyHasTicket = itemName.trim().toLowerCase().startsWith("#inc-");
  const taskLabel = ticketIsValid && !nameAlreadyHasTicket
    ? `Task - ${ticketId} ${itemName}`
    : `Task - ${itemName}`;
  return task.Client_name + ' / ' + task.Project_name + ' / ' + taskLabel;
})(),

        Track_Name: task.Track_Name || null,   // ✅ ADD
        Module_Name: task.Module_Name || null, // ✅ ADD

        Req_id: task.Req_id,
        Item_Name: task.Item_Name,
        Req_name: task.Req_name,
        Item_type: task.Item_type,
        Item_status: task.Item_status,
        Status: task.Status,
        Ticket_id: task.Ticket_id || "",
        disabled: false,
      });
    });

    return Object.values(groupedData);
  };

  const onChange = (rowIndex, newValue, extra) => {
    setValue(newValue);

    //rowIndex=rowIndex-1;

    const selectedNode = extra.triggerNode?.props;

    const updatedData = [...tableData];

    updatedData[rowIndex] = {
      ...updatedData[rowIndex],
      Project_name: selectedNode.project_name,
      Project_id: selectedNode.project_id,
      Employee_id: employee_id,
      Client_id: selectedNode.client_id,
      Client_name: selectedNode.client_name,
      //Expire_Date: filter[3],
      //days: transformedData[rowIndex]?.days || []  // Merge the transformed days here
    };
  };

  const handleSelectChange = (rowIndex, treevalue, value, update) => {
    rowIndex = rowIndex;

    const selectedNode = treevalue?.triggerNode?.props;

    console.log(selectedNode, "selectedNode");

    const updatedData = [...tableData];

    let transformedData;
    if (update == 0) {
      transformedData = tableData.map((client) => ({
        days: client.days.map((day) => ({
          date: day.date,
          WorkItems: [
            {
              ...day,
              task_hours: day.WorkItems[0]["task_hours"],
              ReqId: selectedNode?.Req_id,
              ItemId: value,
              ItemName: selectedNode?.Item_Name,
              itemtype: selectedNode?.Item_type,
              ReqName: selectedNode?.Req_name,
              Item_status: selectedNode?.Item_status,
              Track_Name: selectedNode?.Track_Name || null,   // ✅ ADD
              Module_Name: selectedNode?.Module_Name || null, // ✅ ADD
              Ticket_id: selectedNode?.Ticket_id || "",
            },
          ],
        })),
      }));
    } else {
      transformedData = tableData.map((client) => ({
        days: client.days.map((day) => ({
          date: day.date,
          WorkItems: [
            {
              ReqId: selectedNode?.Req_id,
              ItemId: value,
              ItemName: selectedNode.Item_Name,
              itemtype: selectedNode.Item_type,
              ReqName: selectedNode?.Req_name,
              Item_status: selectedNode.Item_status,
              Track_Name: selectedNode?.Track_Name || null,   // ✅ ADD
              Module_Name: selectedNode?.Module_Name || null, // ✅ ADD

              Ticket_id: selectedNode?.Ticket_id || "",
              ...{ ["task_hours"]: day["task_hours"] },
            },
          ],
        })),
      }));
    }

    updatedData[rowIndex] = {
      ...updatedData[rowIndex],
      Project_name: selectedNode?.Project_name,
      Project_id: selectedNode?.project_id,
      Employee_id: employee_id,
      Client_id: selectedNode?.client_id,
      Client_name: selectedNode?.client_name,
      Expire_Date: selectedNode.Expire_Date,
      days: transformedData[rowIndex]?.days || [],
    };
    //setSelectedvalue(value);
    setTableData(updatedData);
    setweekapproved("0");
  };
  const handleSelectChangeselect = (rowIndex, field, value, extra) => {
    rowIndex = rowIndex - 1;
    handleAddRow(rowIndex, field, value, extra);
  };



  const handlesubmit = async () => {
    let payload_log = {};
    const startDate = formatDateToDDMMYYYY(new Date(selectedDates[0]));
    const endDate = formatDateToDDMMYYYY(new Date(selectedDates[1]));

    // setLoading(true);

    let transformedTableData = [];

    // transformedTableData = tableData?.filter((item) => {
    //   const hasProjectStatus = item?.Project_Status == 1;

    //   const hasTaskStatus = item?.days?.some(day => day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 0));

    //   return hasProjectStatus &&  hasTaskStatus;
    // });

    // let filters = [];

    // filters = backupdata?.WeekData?.filter(item => {
    //   const hasProjectStatus = item?.Project_Status != 1;

    //   const hasTaskStatus = item?.days?.some(day =>
    //     day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 1)
    //   );

    //   console.log(hasTaskStatus, hasProjectStatus, "hasTaskStatus");

    //   return hasProjectStatus || hasTaskStatus;
    // });


    // let arrays = [
    //   ...transformedTableData,
    //   ...(filters?.length > 0 ? filters : []),
    // ];


    // console.log(filters, arrays, "tableDataTransform");


    const payload = {
      Timesheet_id: timesheet_id,
      WeekStartDate: startDate,
      Weekend_date: endDate,
      EmployeeId: localStorage.getItem('employee_id'),
      tableData: tableData,

    };

    // console.log(filters, arrays, "tableDataTransform");


    const filter = tableData.filter((item) => item.Defaults === 0);

    await Timesheetapi.post("api/Projects/AddEmployeeWorkingHours", payload)
      .then(async (response) => {
        success(shouldDelete ? "Successfully Deleted " : "Successfully submitted for approval");

        await gettimesheetdata();
        setLoading(false);
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  const isSameDay = (date1, date2) => {
    return (
      date1.getDate() >= selectedDate[0].getDate() &&
      date1.getDate() <= date2.getDate() &&
      date1.getMonth() >= selectedDate[0].getMonth() &&
      date1.getMonth() <= date2.getMonth() &&
      date1.getFullYear() >= selectedDate[0].getFullYear() &&
      date1.getFullYear() <= date2.getFullYear()
    );
  };

  const formatTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return dayjs().hour(hours).minute(mins);
  };

  const formatTimeHHmm = (strHHmm) => {
    const [hours, minutes] = strHHmm.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    return totalMinutes;
  };

  const formatTimeMMDDYYYY = (dateStr) => {
    const dateDayjs = new Date(dateStr + "T00:00:00");
    const formattedDate = dateDayjs.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
    return formattedDate;
  };

  const formatTimeWithUserTimezone = () => {
    const now = new Date();
    // Detect user's time zone automatically
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return now.toLocaleString("en-US", {
      timeZone: userTimeZone,
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZoneName: "short"
    });
  };


  const handleInputChange = (rowIndex, dayIndex, value) => {
    const [hours, minutes] = value.split(":").map((v) => parseInt(v, 10));
    const totalMinutes = (hours || 0) * 60 + (minutes || 0);
    const updatedData = [...tableData];
    // updatedData[rowIndex].days[dayIndex]["task-hours"] = totalMinutes;
    updatedData[rowIndex].days[dayIndex].WorkItems[0]["task_hours"] =
      totalMinutes;
    updatedData[rowIndex].days[dayIndex].WorkItems[0]["Updated"] = true;
    const newTotals = new Array(7).fill(0);
    updatedData.forEach((row) => {
      row.days.forEach((day, idx) => {
        newTotals[idx] += Number(day["task_hours"] || 0);
      });
    });

    console.log(updatedData, "updatedData");
    setTableData(JSON.parse(JSON.stringify(updatedData)));
    setTotalRowCount(newTotals.map(formatTime));
  };

  const handleWeekSelection = (selectedDates) => {
    if (selectedDates.length > 0) {
      // Normalize input date to local midnight
      const selectedDate = new Date(
        selectedDates[0].getFullYear(),
        selectedDates[0].getMonth(),
        selectedDates[0].getDate()
      );

      const dayOfWeek = selectedDate.getDay();
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

      const startOfWeek = new Date(selectedDate);
      startOfWeek.setDate(selectedDate.getDate() - daysToMonday);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);

      // Save clean week dates (still Date objects)
      setSelectedDates([startOfWeek, endOfWeek]);

      // Build date list for headers
      const newDateList = Array.from({ length: 7 }, (_, index) => {
        const date = new Date(
          startOfWeek.getFullYear(),
          startOfWeek.getMonth(),
          startOfWeek.getDate() + index
        );

        const formattedDate = date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric",
        });

        return {
          accessorKey: formattedDate,
          header: formattedDate,
        };
      });

      setDateList(newDateList);
    }
  };

  const gettimesheetdata = async () => {
    const startDate = formatDateToDDMMYYYY(new Date(selectedDates[0])); // Convert start date
    const endDate = formatDateToDDMMYYYY(new Date(selectedDates[1])); // Convert end date
    setLoading(true);

    try {
      const response = await Timesheetapi.get(
        `api/Projects/GetEmployeeWorkingHours?empid=${localStorage.getItem("employee_id")}&sdate=${startDate}&edate=${endDate}&Role_id=${localStorage.getItem("emp_role_id")}&Teamleadid=${localStorage.getItem("employee_id")}`
      );

      setLoading(false);

      if (response?.data?.WeekData && response.data.WeekData.length > 0) {

        console.log(response.data.WeekData);

        try {
          getApprovalsDetails(localStorage.getItem("employee_id"), startDate, endDate)

        }
        catch (exception) {

        }

        // let filter = [];

        // response.data.WeekData.forEach(item => {
        //   const hasProjectStatus = item?.Project_Status == 1;
        //   const hasTaskStatus = item?.days?.some(day =>
        //     day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 0)
        //   );

        //   if (hasProjectStatus) filter.push(item);
        //   if (hasTaskStatus) filter.push(item);
        // });

        let filter = response.data.WeekData.filter(item => {
          const hasProjectStatus = item?.Project_Status == 1;


          const hasTaskStatus = item?.days?.some(day => day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 0));



          console.log(hasProjectStatus, hasTaskStatus, "DADADADAD")

          return hasProjectStatus && hasTaskStatus;
        });

        console.log(filter, response.data.WeekData, "filterData")
        setbackupdata(response.data);

        setTableData(JSON.parse(JSON.stringify(response.data.WeekData)));

        setTimesheet_id(response.data.Timesheet_id || "");

        const filterser = response.data.WeekData.filter(item => item.Defaults === 0);

        if (filterser.length > 0) {
          // Check if every item in filterser has Approved_status == 1
          const filters = filterser.every(item => item.Approved_status === 1);
          setweekapproved(filters ? "1" : "0");
        } else {
          setweekapproved("0");
        }
      } else {
        setTableData([]);
        setweekapproved("0");
        setApprovedTableData([]);
        setTimesheet_id("");
      }

      if (response?.data) {
        settempTableData(JSON.parse(JSON.stringify(response.data)));
      } else {
        settempTableData([]);
        setApprovedTableData([]);
      }

    } catch (error) {
      setLoading(false);
      setTableData([]);
      settempTableData([]);
      setApprovedTableData([]);
      setweekapproved("0");
      setTimesheet_id("");
      console.error("Failed to fetch timesheet data:", error);

      const errorLog = {
        Error_Message: error,
        Stack_Trace: '',
        Method_Name: `api/Projects/GetEmployeeWorkingHours?empid=${localStorage.getItem("employee_id")}&sdate=${startDate}&edate=${endDate}&Role_id=${localStorage.getItem("emp_role_id")}&Teamleadid=${localStorage.getItem("employee_id")}`,
        File_Name: 'Timesheet.js',
        User_Id: localStorage.getItem("employee_id"),
      };
      ErrorLog(errorLog)

    }
  };
  const getApprovalsDetails = async (empid, sdate, edate) => {

    await Timesheetapi.get(`api/Projects/getApprovaldetrails?empid=${empid}&&sdate=${sdate}&edate=${edate}`).then((Res) => {

      let Approvals = Res.data.Approvals;

      if (Approvals.length > 0) {

        setApprovedTableData(Approvals)

      }
      else {
        setApprovedTableData([]);

      }

    })
  }

  const changeWeek = (direction) => {
    const newDates = [...selectedDates];
    const increment = direction === "next" ? 7 : -7;

    newDates[0] = new Date(
      newDates[0].getTime() + increment * 24 * 60 * 60 * 1000
    );
    newDates[1] = new Date(newDates[0].getTime() + 6 * 24 * 60 * 60 * 1000);

    setSelectedDates(newDates);
    handleWeekSelection(newDates);
  };
  const isSameDayMonthYear = (date1, date2) => {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };

  function getDateInTimeZone(date = new Date(), timeZone = "UTC") {
    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const parts = formatter.formatToParts(date);
    const year = parts.find(p => p.type === "year").value;
    const month = parts.find(p => p.type === "month").value;
    const day = parts.find(p => p.type === "day").value;
    return `${day}-${month}-${year}`;
  }

  function isSameOrBeforeDay(date2Str, timeZone = "UTC") {
    if (!date2Str) return false;
    const [day, month, year] = date2Str.split("-");
    if (!day || !month || !year) return false;

    // Parse the input date string into a Date object in the specified timezone
    const date2 = new Date(`${year}-${month}-${day}T00:00:00Z`);

    // Get today's date in the specified timezone
    const todayParts = getDateInTimeZone(new Date(), timeZone).split("-");
    const [todayDay, todayMonth, todayYear] = todayParts;
    const todayDate = new Date(`${todayYear}-${todayMonth}-${todayDay}T00:00:00Z`);
    console.log(todayDate < date2, todayDate, date2, "todayISO")

    return todayDate < date2;
  }

  const isSameDaydisable = (date1, date2) => {
    if (date1 && date2) {
      const parsedDate1 = dayjs(date1, "DD-MM-YYYY");
      const parsedDate2 = dayjs(date2, "DD-MM-YYYY");
      return parsedDate1.isBefore(parsedDate2);
    }
  };
  const formatTimes = (totalMinutes) => {
    if (isNaN(totalMinutes) || totalMinutes == null) return "00:00"; // Handle NaN or null
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const totalRow = useMemo(() => {
    const newTotals = new Array(7).fill(0); // Assuming 7 days/columns

    // Iterate through the table data
    tableData?.forEach((row) => {
      row?.days?.forEach((day, dayIndex) => {
        // Corrected the spelling and used the dayIndex
        day?.WorkItems?.forEach((workitem) => {
          // Corrected the spelling of WorkItems
          newTotals[dayIndex] += parseInt(workitem["task_hours"] || 0, 10); // Parse task-hours as an integer
        });
      });
    });
    return {
      Project_id: "null",
      Project_name: "Total",
      employee_id: localStorage.getItem("employee_id"),
      days: newTotals.map((total) => ({ task_hours: total })),
    };
  }, [tableData]);

  const totalRowfirst = {
    Project_id: "null",
    Project_name: "Select a Task",
    employee_id: localStorage.getItem("employee_id"),
    days: Array(7).fill({ task_hours: 0 }),
  };

  const HandleModelopen = () => {

  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "client_name",
        header: "Project",
        size: 150,
        Cell: ({ row, dayIndex }) => {
          let isPastDate = false;

          const projectDate = formatDateToDDMMYYYY(new Date(selectedDates[0]))

          if (projectDate) {
            isPastDate = dayjs(projectDate).isBefore(dayjs('2025-04-28'), 'day');
          }



          console.log(projectDate, isPastDate, 'projectDate')
          const isTotalRow =
            row.original.Project_name == "Total" ||
            row.original.Defaults === "1";
          console.log(
            row?.original?.days?.[0]?.WorkItems?.[0]?.["Status"],
            "row.original"
          );

          return isTotalRow ? (
            <Input
              className="w-[150px] timsheet-input"
              value={
                row?.original?.days?.[0]?.WorkItems?.length > 0
                  ? row?.original?.days?.[0]?.WorkItems?.[0]?.ItemName
                  : row.original.Project_name
              }
              disabled={row.original.Project_name != "Select a Task"}
              onClick={handleAddRow}
              style={{
                color:
                  row.original.Project_name == "Select a Task"
                    ? "rgb(58 130 247)"
                    : "black",
              }}
            />
          ) : row.original.Project_name == "Select a Task" ? (
            <div className="relative">




              <Input
                className="w-[150px] text-[#3b82f6] timsheet-input hover:underline"
                value={"Select a task"}
                onClick={(e) => {
                  if (!isPastDate) {
                    handleCellClick(e, row);
                  }
                }}
                style={{
                  // color: isPastDate ? "gray" : "#3b82f6",
                  boxShadow: "none",
                  cursor: isPastDate ? "not-allowed" : "pointer",
                  pointerEvents: isPastDate ? "none" : "auto",
                  backgroundColor: isPastDate ? "#f5f5f5" : "white", // Optional: light gray background when disabled
                }}

              />
            </div>

          ) : (
            row.original.Defaults == "0" && (() => {
              // const projectDate = row?.original?.days?.[0]?.date;
              // const isPastDate = projectDate ? dayjs(projectDate).isBefore(dayjs(), 'day') : false;

              return (
                <div
                  onClick={(e) => {
                    console.log(isPastDate, row?.original?.days?.[0]?.WorkItems?.[0]?.["Status"], "STATUS DATE");
                    if (!isPastDate && (row?.original?.days?.[0]?.WorkItems?.[0]?.["Status"] ? row?.original?.days?.[0]?.WorkItems?.[0]?.["Status"] == 1 : true)) {

                      handleCellClick(e, row);
                    }
                  }}
                  style={{
                    cursor: isPastDate ? 'not-allowed' : 'pointer',
                  }}
                >
                  <span
                    style={{
                      color: isPastDate ? 'gray' : 'inherit',
                    }}
                  >
                    {/* {row?.original?.days?.[0]?.WorkItems?.length > 0
                      ? ((row.original.Project_name === row?.original?.days?.[0]?.WorkItems?.[0]?.ItemName) ? row.original.Project_name : `${row.original.Project_name} / ${row?.original?.days?.[0]?.WorkItems?.[0]?.ItemName}`)
                      : row.original.Project_name || "Select Project"} */}

                    {(() => {
                      const wi = row?.original?.days?.[0]?.WorkItems?.[0];
                      const parts = [row.original.Project_name];
                      if (wi?.Track_Name) parts.push(wi.Track_Name);
                      if (wi?.Module_Name) parts.push(wi.Module_Name);

                      // if (wi?.ItemName) parts.push(`Task - ${wi.ItemName}`);

                      if (wi?.ItemName) {
  const ticketId = wi?.Ticket_id ? String(wi.Ticket_id).trim() : "";
  const ticketIsValid = ticketId.toLowerCase().startsWith("#inc-");
  const nameAlreadyHasTicket = wi.ItemName.trim().toLowerCase().startsWith("#inc-");
  const taskLabel = ticketIsValid && !nameAlreadyHasTicket
    ? `Task - ${ticketId} ${wi.ItemName}`
    : `Task - ${wi.ItemName}`;
  parts.push(taskLabel);
}
                      return parts.join(' / ');
                    })()}




                  </span>
                </div>
              );
            })()

          );
        },
      },


      ...dateList.map((date, index) => ({
        accessorKey: date.accessorKey,
        header: date.header,
        size: 120,
        Cell: ({ row }) => {
          const rowIndex = row.index;
          const dayIndex = index;
          const dateForCell = row.original?.days?.[dayIndex]?.date || null;
          let expireDate = row?.original?.Expire_Date || null;
          const formattedDateForCell = dateForCell ? dayjs(dateForCell).format("DD-MM-YYYY") : null;
          const formattedExpireDate = expireDate ? dayjs(expireDate).format("DD-MM-YYYY") : null;
          const formattedDateForCelldisble = isSameDaydisable(dayjs().startOf('day'), formattedDateForCell);

          const isExpired = formattedExpireDate != null && isSameOrBeforeDay(formattedExpireDate);

          const isExpireitems = row.original.days?.[dayIndex].WorkItems?.[0]?.["Emp_Task_Status"] == 1;
          const isProjectNameValid = row.original.Project_name !== "Total" && row.original.Project_name !== "Select a Task";
          const isDisabled = !isProjectNameValid;
          const currentMinutes = row.original.days?.[dayIndex].WorkItems?.[0]?.["task_hours"] || 0;
          const formattedTime = formatTime(currentMinutes);
          const task_Id = row.original.days?.[0].WorkItems?.[0]?.["ItemId"] || 0;
          const Status = row.original.days?.[0].WorkItems?.[0]?.["Status"] == 0 ? true : false;

          const Project_Status = row?.original?.Project_Status || null;

          console.log("formattedDateForCelldisble", Project_Status, isExpireitems)
          return (
            <>
              {row.original.Project_name == "Select a Task" ? (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={["TimeField", "TimeField", "TimeField"]}
                  >
                    <Tooltip
                      placement="leftTop"
                      title="Select a task or add a new task."
                      arrow={mergedArrow}
                    >
                      <TimeField
                        className="custom_time"
                        value={
                          row.original.Project_name !== "Total"
                            ? formattedTime
                            : formatTime(
                              row.original.days?.[dayIndex]?.["task_hours"]
                            )
                        }
                        disabled={true} //|| (row?.original?.Expire_Date && !isSameDaydisable(row?.original?.Expire_Date, row?.original?.Expire_Date)) row.original.Project_name === 'Total'|| row.original.Project_name == "Select a Task"  ||    || (weekapproved == 1 && localStorage.getItem("emp_role_id") == 1)
                        format="HH:mm"
                      />
                    </Tooltip>
                  </DemoContainer>
                </LocalizationProvider>
              )
                : (isExpired != null && formattedExpireDate != null && !isExpired && row.original.Project_name != "Total") || (Project_Status != null && Project_Status != 1 || isExpireitems && row.original.Project_name != "Total") ? (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      components={["TimeField", "TimeField", "TimeField"]}
                    >
                      <Tooltip
                        placement="leftTop"
                        title={!isExpired ? "Project date is Expired." : Project_Status != 1 ? "Project is  Closed" : isExpireitems ? "Task is Removed " : ""}
                        arrow={mergedArrow}
                      >
                        <TimeField
                          className="custom_time"
                          value={
                            row.original.Project_name !== "Total"
                              ? formattedTime
                              : formatTime(
                                row.original.days?.[dayIndex]?.["task-hours"]
                              )
                          }
                          disabled={Status || formattedDateForCelldisble || isDisabled || isExpireitems || !isExpired}
                          format="HH:mm"
                          onChange={(newValue) => {
                            const formattedValue = `${newValue.hour()}:${newValue.minute()}`;
                            handleInputChange(rowIndex, dayIndex, formattedValue);
                          }}
                        />
                      </Tooltip>
                    </DemoContainer>
                  </LocalizationProvider>
                )
                  : (
                    !Loading &&
                    tableData.length > 0 && (
                      <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            components={["TimeField", "TimeField", "TimeField"]}
                          >
                            <TimeField
                              className="custom_time"
                              value={
                                row.original.Project_name !== "Total"
                                  ? formattedTime
                                  : formatTime(
                                    row.original.days?.[dayIndex]?.[
                                    "task_hours"
                                    ] || 0
                                  )
                              }
                              readOnly={true}
                              disabled={
                                (formattedExpireDate != null && !isExpired) ||
                                Status ||
                                formattedDateForCelldisble ||
                                row.original.Project_name === "Total" ||
                                row.original.Project_name == "Select a Task" ||
                                (row?.original?.Approved_status &&
                                  row?.original?.Approved_status == 1 &&
                                  localStorage.getItem("emp_role_id") == 1) ||
                                isDisabled
                              }
                              format="HH:mm"

                              onClick={() => (row.original.Defaults == 0) && showModal(
                                task_Id,
                                rowIndex,
                                dayIndex,
                                formatTime(row.original.days?.[dayIndex]["WorkItems"][0]?.["task_hours"] || 0),
                                row.original.days?.[dayIndex]["WorkItems"][0]?.["task_hours"],
                                row.original.days?.[dayIndex]["WorkItems"][0]?.["ItemName"],
                                row.original.days?.[dayIndex]["date"],
                                row.original
                              )}

                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </>
                    )
                  )}
            </>
          );
        },
      })),



      {
        accessorKey: "Total",
        header: "WeekTotal",
        size: 100,
        Cell: ({ row, index }) => {
          const isTotalRow =
            row.original.Project_name === "Total" ||
            row.original.Defaults === "1";
          let weekTotalMinutes = 0;
          if (
            row.original.Project_name === "Total" ||
            row.original.Project_name === "Select a Task"
          ) {
            weekTotalMinutes = row?.original?.days?.reduce((acc, day) => {
              return acc + parseInt(day["task_hours"] || 0, 10);
            }, 0);
          } else {
            weekTotalMinutes = row?.original?.days?.reduce((acc, day) => {
              const dayTotal = day?.WorkItems?.reduce((dayAcc, workItem) => {
                return dayAcc + parseInt(workItem["task_hours"] || 0, 10);
              }, 0);
              return acc + dayTotal;
            }, 0);
          }
          // Format the total time in HH:mm
          const formattedWeekTotal = formatTimes(weekTotalMinutes);
          return (
            <>
              <label
                className="w-[150px] timesheet-input"
                style={{ color: "black" }}
              >
                {formattedWeekTotal}
              </label>
            </>
          );
        },
      },
      // {
      //   accessorKey: "actions",
      //   header: "Actions",
      //   size: 100,
      //   Cell: ({ row }) => {
      //     const isTotalRow =
      //       row.original.Project_name === "Total" ||
      //       row.original.Defaults === "1";
      //     return isTotalRow ||
      //       row.original.Project_name == "Select a Task" ? null : (
      //       <div className="text-center">
      //         <Tooltip title="Delete">
      //           { }
      //           <IconButton
      //             onClick={() => handleDeleteRow(row.index, row)}
      //             disabled={
      //               row?.original?.Approved_status &&
      //               row?.original?.Approved_status == 1 &&
      //               localStorage.getItem("emp_role_id") == 1
      //             }
      //             size="small"
      //             style={{ color: "red" }}
      //           >
      //             <i class="fa fa-trash"></i>
      //           </IconButton>
      //         </Tooltip>
      //       </div>
      //     );
      //   },
      // },
    ],
    [dateList, tableData, treeData, handleCellClick]
  );

  const handleclick = async (values, data) => {
    let rowIndex = 0;
    let transformed = {
      triggerNode: {
        props: {
          ...data,
          disabled: true,
        },
      },
    };
    // handleSelectChangeselect(row.index, 'project', e, extra); setTasklists(1)
    console.log(values, transformed);
    await handleAddRow(rowIndex, "Project", data.value, transformed);
    setDropdownPosition(null);
    setActiveRowIndex(null);
    // if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
    //   setDropdownPosition(null);
    //   setActiveRowIndex(null);
    // }
  };

  const handleclickchange = async (index, values, data) => {
    let transformed = {
      triggerNode: {
        props: {
          ...data,
        },
      },
    };

    console.log(values, tableData[index], "HELLO");



    const row = tableData[index]; // this is an array

    let transformedTableData = [];

    // Get project status at index 8
    const hasProjectStatus = row.Project_Status != 1;

    // Get days array at index 10
    const hasTaskStatus = Array.isArray(row.days) && row.days.some(day => day?.WorkItems?.some(wi => wi?.Emp_Task_Status == 1));

    // If either condition is true, mark this row
    if (hasProjectStatus || hasTaskStatus) {
      console.log(hasProjectStatus, hasTaskStatus, "hasTaskStatus")
      transformedTableData.push(row);
    }

    if (transformedTableData.length > 0) {
      console.log(transformedTableData, "Matching item found — exiting function early");
      return;
    }
    await handleSelectChange(index, transformed, data.value, 0);
    setDropdownPosition(null);
    setActiveRowIndex(null);
  };




  // const HandleSearch = (value) => {
  //   console.log("Search value:", value);

  //   const filtered = search.map(item => {
  //     const filteredChildren = item.children?.filter(child =>
  //       child.project_name?.toLowerCase().includes(value.toLowerCase())
  //     );

  //     return {
  //       ...item,
  //       children: filteredChildren
  //     };
  //   }).filter(item => item.children && item.children.length > 0);
  //   console.log("Filtered data:", filtered);

  //   settreeData(filtered);
  // };

  const HandleSearch = (value) => {
  console.log("Search value:", value);

  const lowerVal = value.toLowerCase();

  const filtered = search.map(item => {
    const filteredChildren = item.children?.filter(child => {
      const matchesName = child.project_name?.toLowerCase().includes(lowerVal);
      const ticketId = child.Ticket_id ? String(child.Ticket_id).trim().toLowerCase() : "";
      const matchesTicket = ticketId.startsWith("#inc-") && ticketId.includes(lowerVal);
      return matchesName || matchesTicket;
    });

    return {
      ...item,
      children: filteredChildren
    };
  }).filter(item => item.children && item.children.length > 0);

  console.log("Filtered data:", filtered);
  settreeData(filtered);
};


  const renderDropdown = () => {
    if (!dropdownPosition || activeRowIndex === null) return null;

    const row = tableData[activeRowIndex];
    // if (!row || row.Defaults !== '0') return null;

    console.log(row, "dropdownPosition");

    return createPortal(
      <div
        ref={dropdownRef}
        className="custom-dropdown_box bg-white shadow-lg border"
        style={{
          position: "absolute",
          top: dropdownPosition.top,
          left: dropdownPosition.left,
          width: `${size.width}px`,
          height: `${size.height}px`,
          zIndex: 1000,
        }}
      >
        <div className="draggabe_box relative">
          <div className="px-[18px]">
            <Search
              placeholder="Search project or client"
              className="w-full task-select"
              allowClear
              onChange={(e) => { HandleSearch(e.target.value) }}
              onSearch={() => { console.log('search') }}
            />
          </div>

          <div className="my-3">
            <div className="flex items-center justify-between text-xs text-gray-500 font-medium mb-2 px-[20px]">
              <p className="text-[12px]">Tasks</p>
              <div
                className="flex items-center gap-1 cursor-pointer"
                onClick={handleListToggle}
              >
                <p>{`${treeData.length} ${treeData.length <= 1 ? ('task') : ('tasks')}`}</p>
                {isListExpanded ? (
                  <IoIosArrowUp className="text-[15px]" />
                ) : (
                  <IoIosArrowDown className="text-[15px]" />
                )}
              </div>
            </div>
            {
              dropdownLoad ? (
                <Skeleton active className="px-[20px]" />
              ) : (
                treeData.length <= 0 ? (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Task" />
                ) : (
                  isListExpanded && (
  <ul className="text-sm mt-3">
    {treeData.map((project, index) => {
      const itemKey = `${project.key}-${index}`;
      const isDisabled =
        project?.children[0]?.disabled &&
        project?.children[0]?.Item_status !== "Completed";
      const isCompleted = project?.children[0]?.Item_status === "Completed";
      const isTruncated = truncatedMap[itemKey];

      const tooltipTitle = isTruncated
        ? project.title
        : isDisabled
        ? "Already Selected"
        : isCompleted
        ? "Task Status is Completed"
        : "Select a task";

      return (
  <React.Fragment key={itemKey}>
    <Tooltip placement="bottom" title={tooltipTitle} arrow={mergedArrow} overlayStyle={{ maxWidth: "none" }}
  overlayInnerStyle={{ whiteSpace: "nowrap" }}>
      <li className="text-xs text-[#555]">
        <div className="flex items-center justify-between w-full px-[20px]">
          <button className="flex items-center gap-2 w-[85%] min-w-0">
            <span className="w-2 h-2 rounded-full bg-purple-600 inline-block shrink-0"></span>
            {React.cloneElement(project.title, {
              ref: (el) => (itemRefs.current[itemKey] = el),
              onMouseEnter: (e) => {
                const el = e.currentTarget;
                const truncated = el.scrollWidth > el.clientWidth;
                setTruncatedMap((prev) =>
                  prev[itemKey] === truncated ? prev : { ...prev, [itemKey]: truncated }
                );
              },
              onClick: () => {
                if (isDisabled || isCompleted) return;
                row === undefined
                  ? handleclick(project.title, project.children[0])
                  : handleclickchange(activeRowIndex, project.title, project.children[0]);
              },
            })}
          </button>
        </div>
      </li>
    </Tooltip>
  </React.Fragment>
);
    })}
  </ul>
)
                )
              )
            }


            {/* {isListExpanded && (
              <ul className="text-sm mt-3">
                {treeData.map((project, index) => (
                  <React.Fragment key={`${project.key}-${index}`}>
                    <Tooltip
                      placement="leftTop"
                      title={
                        project?.children[0]?.disabled && project?.children[0]?.Item_status !== "Completed"
                          ? "Already Selected"
                          : project?.children[0]?.Item_status === "Completed"
                            ? "Task Status is Completed"
                            : "Select a task"
                      }
                      arrow={mergedArrow}
                    >
                      <li className="text-xs text-[#555]">
                        <div className="flex items-center justify-between w-full px-[20px]">
                          <button className="flex items-center gap-2 w-[85%]">
                            <span className="w-2 h-2 rounded-full bg-purple-600 inline-block"></span>
                            <p
                              className="text-[#353535] w-[100%] truncate text-start"
                              onClick={() => {
                                if (project?.children[0]?.disabled || project?.children[0]?.Item_status === "Completed") return;
                                row === undefined
                                  ? handleclick(project.title, project.children[0])
                                  : handleclickchange(activeRowIndex, project.title, project.children[0]);
                              }}
                            >
                              {project.title}
                            </p>
                          </button>
                        </div>
                      </li>
                    </Tooltip>
                  </React.Fragment>
                ))}


              </ul>
            )} */}
          </div>
        </div>
        <div
          className="absolute bottom-[5px] right-[5px] cursor-se-resize"
          onMouseDown={startResizing}
        >
          <img src="/resize.svg" alt="Resize" />
        </div>
      </div>,
      document.getElementById("custom-dropdown-portal") || document.body
    );
  };

  const AddTask = (value, data) => {

    setTasklists(data[0]);
    setIsModalVisible({ visible: true, name: `${data[0].Project_name} / Create task` });
    setDropdownPosition(null);
    setActiveRowIndex(null);

    console.log(data, treeData, "DATA ON FORM");
  };

  const getclients = async () => {
    const storedClientIds =
      JSON.parse(localStorage.getItem("Emp_Assign_client")) || []; // Fetch data from the API
    const response = await Timesheetapi.get(
      `api/Projects/getProjManagerclients?empid=${localStorage.getItem(
        "emp_role_id"
      )}&clientid=${storedClientIds}`
    );
    const clientOptions = response.data.Client.filter((project) =>
      storedClientIds.includes(project.Client_id)
    )
      .map((project) => ({
        value: project.Client_id,
        label: project.Client_name,
      }))
      .filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );

    setClient(clientOptions);
  };

  const getprojectList = async (client_id) => {
    // setLoading(true);

    const response = await Timesheetapi.get(
      `api/projects/getRequirements?empid=${localStorage.getItem(
        "employee_id"
      )}&Role_Id=${5}&Client_id=${client_id}`
    );
    const memberOptions = response.data.Result.map((Team) => ({
      value: Team.Project_id,
      label: Team.projectname,
    }));
    setRequirements(memberOptions);
  };

  const handleTaskSubmit = async (values) => {
    console.log("Values", values);

    const now = new Date();
    const formattedDateTime = now.toISOString().slice(0, 19).replace("T", " ");
    let payload = {
      Item_Id: 0,
      Req_Id: 0,
      Projectid: Tasklists.project_id,
      clientid: Tasklists.client_id,
      itemname: values.title,
      itemtype: "Task",
      assign_by: localStorage.getItem("employee_id"),
      assign_to: localStorage.getItem("employee_id"),
      item_sdate: formattedDateTime,
      item_edate: formattedDateTime,
    };

    await Timesheetapi.post("api/Projects/addEmployeeWorkItem", payload).then(
      async (response) => {
        console.log("response", response?.data?.data);
        if (response.data.status == 1) {
          setLoading(true);
          // await getprojectname(localStorage.getItem("employee_id"));
          console.log(response.data.message, "Messagessss");
          let rowIndex = 1;

          let transformed = {
            triggerNode: {
              props: {
                value: response?.data?.data?.Item_Id,
                client_id: Tasklists.client_id,
                project_id: Tasklists.project_id,
                client_name: response?.data?.data?.Client_Name,
                Project_name: response?.data?.data?.Project_Name,
                Item_Name: values.title,
                project_name: values.title,
                Item_type: "Task",
                Item_status: "Active",
                "Item_Id:": response?.data?.data?.Item_Id,
                disabled: false,
              },
            },
          };

          console.log("transformed", transformed);
          await handleAddRow(
            rowIndex,
            "Project",
            response?.data?.data?.Item_Id,
            transformed
          );
          message.success(
            "Task successfully created and added to your workspace."
          );
          setLoading(false);
          setIsModalVisible({ visible: false, name: '' });
          form.resetFields();
        }
      }
    ).catch((err) => {

      const errorLog = {
        Error_Message: err,
        Stack_Trace: '',
        Method_Name: `api/Projects/addEmployeeWorkItem`,
        File_Name: 'Timesheet.js',
        User_Id: localStorage.getItem("employee_id"),
      };
      ErrorLog(errorLog)
    })
  };


  const HandleDeleteComments = async (e) => {
    setIsDeletingComment(true);
    console.log(e, "Values")
    const commentId = e.content_Id;
    const parsedChangeHours = dayjs(e.Changed_Hrs, "HH:mm");
    const totalMinutes = parsedChangeHours.hour() * 60 + parsedChangeHours.minute();

    // setIsLoadComments(true);
    let subtraction = Time - totalMinutes

    const finalTime = await formatTime(subtraction);
    const parsedFinalTime = dayjs(finalTime, "HH:mm");

    console.log("parsedFinalTime", finalTime)

    await handleInputChange(taskId.rowIndex, taskId.dayIndex, parsedFinalTime.format("HH:mm"));

    setTime(parseInt(subtraction))

    const res = await Timesheetapi.post(`api/Projects/DeleteComments?comment_Id=${commentId}`);

    if (res.data === "Success") {
      const Res = await Timesheetapi.get(
        `api/Projects/GetComments?empid=${localStorage.getItem("employee_id")}&role_id=${localStorage.getItem("employee_id")}&task_id=${taskId.task_Id}&&sdate=${taskId.task_Date}`);
      setComments(Res?.data?.Comments);
      await handlesubmit();

      setchangehours(dayjs("00:00", "HH:mm"));
      success("Updated successfully.");
    }

    setIsDeletingComment(false);


  }

  return (
    <div className="w-full h-full flex justify-center">
      <Box className="custom-material mt-[33px] ">
        {contextHolder}
        {contextHolder1}
        <ToastContainer />
        {!Loading ? (
          <>
            <div className="timesheet_custom_table timesheet_section">
              <MaterialReactTable
                columns={columns}
                data={[...tableData, totalRowfirst, totalRow]}
                enableColumnActions={false}
                enableColumnFilters={false}
                enableFullScreenToggle={false}
                enableDensityToggle={false}
                enableColumnVisibility={false}
                enableSorting={false}
                enableGlobalFilter={false}
                enableHiding={false}
                enablePagination={false}

                muiTableHeadCellProps={focusHeadCellProps}
                muiTableBodyCellProps={focusBodyCellProps}

                renderTopToolbarCustomActions={() => (
                  <>
                    <div className="flex items-center gap-3 justify-between w-full">
                      <div className="flex items-center gap-3">
                        <div className="flex items-center justify-between px-4">
                          <span className="page-heading">ACTIVITY CARD</span>
                          {/* [Dashboard link] tell the user which day needs filling */}
                          {focusColumnKey && dateList.some((d) => d.accessorKey === focusColumnKey) && (
                            <span
                              className="ml-3 text-[12px] font-semibold rounded-full px-3 py-1"
                              style={{ background: "#FDE6D6", color: "#9A3412", border: "1px solid #F6C9A8" }}
                            >
                              Missed: {focusColumnKey}
                            </span>
                          )}
                        </div>

                        {/* ✅ Project Cards */}
                        {projectCards.length > 0 && (
                          <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '10px',
                            width: '100%',
                          }}>
                            {projectCards.map((card, idx) => (
                              <div
                                key={idx}
                                style={{
                                  border: `2px solid ${card.color.border}`,
                                  borderRadius: '8px',
                                  backgroundColor: card.color.bg,
                                  padding: '5px',
                                  minWidth: '140px',
                                  display: 'flex',
                                  gap: '5px',
                                  flexDirection: 'row',
                                  alignItems: 'baseline',
                                  justifyContent: 'center',
                                  boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                                }}
                              >
                                <span style={{
                                  fontSize: '11px',
                                  fontWeight: '600',
                                  color: '#555',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '130px',
                                }} title={card.name}>
                                  {card.name}
                                </span>
                                <span style={{
                                  fontSize: '16px',
                                  fontWeight: '700',
                                  color: card.color.text,
                                  marginTop: '',
                                }}>
                                  {card.formatted}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>


                      {/* Date picker — unchanged */}
                      <div className="">
                        <div className="flex items-start">
                          <div className="custom-flatpicker">
                            <Flatpickr
                              className="date-picker"
                              value={selectedDates}
                              options={{
                                mode: "range",
                                dateFormat: "D, M j",
                                maxDate: selectedDate[1],
                                onChange: handleWeekSelection,
                              }}
                            />
                          </div>
                          <div
                            className="custom-flatpicker"
                            style={{ padding: "9px 10px 8px", borderLeft: "0px", cursor: "pointer" }}
                            onClick={() => changeWeek("prev")}
                          >
                            <MdOutlineArrowBackIos className="text-[12px]" />
                          </div>
                          <div
                            className="custom-flatpicker"
                            onClick={() => {
                              if (selectedDate[1] && selectedDates[1] && !isSameDayMonthYear(selectedDate[1], selectedDates[1])) {
                                changeWeek("next");
                              }
                            }}
                            style={{
                              padding: "9px 10px 8px",
                              borderLeft: "0px",
                              cursor: selectedDate[1] && selectedDates[1] && isSameDayMonthYear(selectedDate[1], selectedDates[1])
                                ? "not-allowed" : "pointer",
                            }}
                          >
                            <MdOutlineArrowForwardIos className="text-[12px]" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              />
              {renderDropdown()}
            </div>

            <div className="mt-3">
              <StatusTable
                tableData={approvedTableData}
              />
            </div>

            <>
              <Modal
                title={
                  <>
                    <ExclamationCircleFilled
                      style={{ color: "orange", marginRight: "8px" }}
                    />{" "}
                    Confirm
                  </>
                }
                visible={isModalOpen}
                onOk={confirmDelete}
                onCancel={cancelDelete}
                footer={[
                  <Button key="cancel" onClick={cancelDelete}>
                    Cancel
                  </Button>,
                  <Button key="confirm" type="primary" onClick={confirmDelete}>
                    Delete
                  </Button>,
                ]}
              >
                <p>Are you sure you want to delete this row?</p>
              </Modal>
            </>

            <>
              <Modal
                className="workitem-popup"
                title={isModalVisible.name}
                open={isModalVisible.visible}
                onOk={toggleModal}
                onCancel={toggleModal}
                footer={null}
              >
                <div className="bg-white rounded-lg">
                  <Form
                    form={form}
                    onFinish={handleTaskSubmit}
                    layout="vertical"
                  >
                    {/*  */}
                    <div className="grid grid-cols-1 gap-x-4">
                      <div>
                        <Form.Item
                          label={`Title`}
                          name="title"
                          placeholder="Please select"
                          rules={[
                            { required: true, message: "Enter the title" },
                          ]}
                        >
                          <Input className="h-10"></Input>
                        </Form.Item>
                      </div>
                    </div>

                    <Form.Item className="text-right footer-form-item">
                      <Button
                        type="default"
                        onClick={toggleModal}
                        style={{ marginRight: "8px" }}
                      >
                        Cancel
                      </Button>
                      <Button type="primary" htmlType="submit">
                        Create
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </Modal>
            </>

            {weekapproved == "1" && localStorage.getItem("emp_role_id") == 1 ? (
              <div
                className="flex items-center gap-[20px]"
                style={{
                  justifyContent: "end",
                  position: "relative",
                  right: "1rem",
                  top: "-3.1rem",
                }}
              >
                <Button
                  className="approve-btn bg-blue-500 text-white py-1.5 px-3 rounded flex items-center relative top-[4px] z-[9] left-[10px]"
                //onClick={handlesubmit}
                >
                  Weekly approved success
                </Button>
              </div>
            ) : (
              <div
                className="flex items-center gap-[20px]"
                style={{
                  justifyContent: "end",
                  position: "relative",
                  right: "1rem",
                  top: "-3.1rem",
                }}
              >
                {/* <Button
                  className="approve-btn bg-blue-500 text-white py-1.5 px-3 rounded flex items-center relative top-[4px] z-[9] left-[10px]"
                  onClick={handlesubmit}
                >
                  {localStorage.getItem("emp_role_id") == 1
                    ? " SUBMIT FOR APPROVAL"
                    : " SAVE AND SUBMIT"}
                </Button> */}
              </div>
            )}
          </>
        ) : (
          <>
            <Spin tip="Loading...">
              <MaterialReactTable
                columns={columns}
                data={[...tableData, totalRowfirst, totalRow]}
                enableColumnActions={false}
                enableColumnFilters={false}
                enableFullScreenToggle={false}
                enableDensityToggle={false}
                enableColumnVisibility={false}
                enableSorting={false}
                enableGlobalFilter={false}
                enablePagination={false}
                muiTableHeadCellProps={focusHeadCellProps}
                muiTableBodyCellProps={focusBodyCellProps}
              />
              {renderDropdown()}
            </Spin>
          </>
        )}
      </Box>


      <Modal
        className="custom-project_modal"
        title={`${taskId?.task_Name}  |  ${taskId?.task_Date && convertToDDMMYYYY(taskId?.task_Date)}`}
        open={isProjectModalOpen}
        closable
        maskClosable={false}
        keyboard={false}
        footer={false}
        onCancel={!isLoadComments && !isDeletingComment ? handleCancel : undefined}
      >

        <div>
          {/* Task Description and Billing Status Section */}
          {(taskId?.task_Description || taskId?.Billing_Status) && (
            <div style={{ border: '1px solid #e8e8e8', padding: '12px', borderRadius: '5px', marginBottom: '15px', backgroundColor: '#fafafa' }}>
              {taskId?.task_Description && (
                <div style={{ marginBottom: '10px' }}>
                  <p style={{ fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '5px' }}>Task Description</p>
                  <div style={{ fontSize: '13px', color: '#666', backgroundColor: '#fff', padding: '8px', borderRadius: '3px', minHeight: '40px' }}>
                    {taskId.task_Description}
                  </div>
                </div>
              )}
              {taskId?.Billing_Status && (
                <div>
                  <p style={{ fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '5px' }}>Billing Status</p>
                  <span style={{
                    fontSize: '12px',
                    fontWeight: '500',
                    padding: '4px 10px',
                    borderRadius: '3px',
                    backgroundColor: taskId.Billing_Status === 'billable' ? '#d4edda' : '#fff3cd',
                    color: taskId.Billing_Status === 'billable' ? '#155724' : '#856404'
                  }}>
                    {taskId.Billing_Status === 'billable' ? 'Billable' : taskId.Billing_Status === 'non-billable' ? 'Non-Billable' : taskId.Billing_Status}
                  </span>
                </div>
              )}
            </div>
          )}

          <div style={{ border: '1px solid #cccccc', padding: '10px', borderRadius: '5px' }}>
            <div className="quill_wrapper">
              <div className="w-[100%]">
                <p className="text-[13px] text-[#555] font-[600] mb-2">What did you do today?</p>
                <TextArea classNames="input-comments" placeholder="Add your comments here." onChange={(e) => setInputComments(e.currentTarget.value)} value={inputComments} readOnly={isLoadComments || isDeletingComment} />
              </div>

            </div>
            <div className="flex items-center gap-2 justify-end mt-3">
              <div className="input_wrapper">
                <p className="text-[12px] text-[#555] font-[600]">{'Worked Hours (HH:MM) : '}</p>
                <div className="custom_hours">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer
                      components={["TimeField", "TimeField", "TimeField"]} >
                      <TimeField
                        className={`custom_time custom_time-field ${exceededCommentLimit ? 'custom_time-error-border' : ''}`}
                        format="HH:mm"
                        value={changehours}
                        minTime={dayjs("00:00", "HH:mm")}
                        onChange={(newValue) => {


                          // If user clears or gives an invalid value
                          if (!newValue || !dayjs(newValue).isValid() || newValue.isBefore(dayjs("00:00", "HH:mm"))) {
                            console.log(newValue, "gytytt")
                            setValue(dayjs(newValue).isValid())
                            // setchangehours(dayjs("00:00", "HH:mm"));
                          } else {
                            setdeletedata(newValue.hour())
                            setValue(dayjs(newValue).isValid())
                            const formattedValue = newValue.format("HH:mm");
                            const [hours, minutes] = formattedValue.split(":").map(Number);
                            const enteredMins = hours * 60 + minutes;


                            if (newValue.hour() && newValue.hour() > 0) {
                              console.log("TYPE?", newValue.hour())
                            }
                            if ((enteredMins + taskId.current_Total) < 1440) {

                              if (enteredMins <= 240) {
                                setExceededCommentLimit(false);
                                setchangehours(newValue);
                                return
                              }
                              else {
                                openNotification('Comment Hour Limit Exceeded', 'Max 4 hours allowed per comment');
                                setchangehours(newValue);
                                setExceededCommentLimit(true);
                                return
                              }
                            }
                            else {
                              setExceededCommentLimit(false);
                              openNotification('Daily Hour Limit Exceeded', 'Max 24 hours allowed per day');
                              setchangehours(dayjs("00:00", "HH:mm"));
                              return
                            }

                          }
                        }}
                        disabled={isLoadComments || isDeletingComment}

                      />


                    </DemoContainer>
                  </LocalizationProvider>
                </div>

              </div>
              <div className="flex items-center gap-1.5">
                <Button onClick={!isLoadComments && !isDeletingComment ? handleClear : undefined} className="h-[35px] px-[25px]" style={isLoadComments || isDeletingComment ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}>Clear</Button>
                <Button className="text-[#fff] bg-[#4096ff] h-[35px] px-[25px]" onClick={!isLoadComments && !isDeletingComment ? handleOk : undefined} style={isLoadComments || isDeletingComment ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}>{!isLoadComments ? 'Save' : 'Saving...'}</Button>
              </div>
            </div>

          </div>

          <div className="mt-4">

            {/* <p className="text-[13px] text-[#555] font-[600]">Comments : </p> */}
            {isLoadComments || isDeletingComment ? (

              <Skeleton active />
            ) : (
              <div className="mt-1 mb-3">
                {Comments?.map((employee, empIndex) => (
                  <div key={empIndex} className="comment-box">
                    {employee.Comment_By_Date?.map((dateGroup, dateIndex) => (
                      <div key={dateIndex} className="comment-child">
                        <div className="flex justify-center">
                          <div className="day_box">
                            {checkDate(dateGroup.Date)}
                          </div>

                        </div>
                        <p className="name-label">{employee.Emp_name} :</p>
                        {dateGroup.Comments_Per_Day?.map((comment, commentIndex) => (
                          <div key={commentIndex} className="mb-0">

                            <div className="flex items-center justify-between mb-1">

                            </div>

                            <div className="flex items-start justify-between">
                              <div className="flex items-baseline">
                                <p className="time-label flex items-center gap-1">
                                  {comment?.Created
                                    ? new Date(comment.Created + 'Z').toLocaleTimeString([], {
                                      hour: '2-digit',
                                      minute: '2-digit',
                                      // second: '2-digit', 
                                      hour12: true,
                                    })
                                    : "00:00"}
                                </p>

                                <p className="w-[10px]">:</p>
                                <p className="comment-text"
                                  data-id={comment.content_Id}
                                  data-raw={comment.Changed_Hrs}
                                  dangerouslySetInnerHTML={{
                                    __html: `${comment.content
                                      .replace(/ /g, '&nbsp;')   // Convert spaces (optional)
                                      .replace(/\n/g, '<br>')}`
                                  }}
                                />
                              </div>
                              <div className="flex items-center gap-2 whitespace-nowrap">
                                <p className="hours-label">Hrs : </p>
                                <p className="hours-label">{comment.Changed_Hrs || "-"}</p>
                                {!isLoadComments && !isDeletingComment ?
                                  (<Popconfirm
                                    title="Delete the comment"
                                    description="Are you sure to delete this comment?"
                                    icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                    onConfirm={() => HandleDeleteComments(comment)}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <Button variant="link" color="danger" style={{ padding: '0px' }}> <DeleteOutlined /></Button>
                                  </Popconfirm>)
                                  : null
                                }

                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}

          </div>

        </div>

      </Modal>
    </div >
  );
};